{
  "zh-CN": {
    "labels": {
      "saved": "已保存",
      "hangarShare": {
        "intro": "创建一个私密链接，即使你的机库设为私密，拿到链接的人也能查看你的机库及其统计数据。你的愿望单仍遵循其自身的设置。",
        "howTo": "任何拥有此链接的人都能查看你的机库。重置链接可让持有当前链接的人失去访问权限，删除链接则停止分享。"
      },
      "locationInput": {
        "linked": "已关联到"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "全部",
        "search": "在此商店中搜索",
        "categories": "类别",
        "sortName": "名称",
        "sortPrice": "价格",
        "emptyName": "物品",
        "kind": "商店",
        "items": "商品",
        "facts": "关键信息",
        "place": "地点",
        "system": "星系",
        "carries": "出售",
        "source": "价格与库存来自 UEX。"
      },
      "location": {
        "missionsSample": "计数仅涵盖 %{total} 个中的前 %{shown} 个。",
        "people": "在此的好友与舰队成员",
        "peopleFriend": "好友",
        "peopleUnlisted": "另有 %{count} 人未列出",
        "systemUnavailable": "无法加载此星系。",
        "systemsUnavailable": "无法加载星系。",
        "resourceKinds": {
          "ship_mineables": "飞船采矿",
          "hand_mineables": "手持采矿",
          "ground_vehicle_mineables": "地面载具采矿",
          "harvestables": "可采集物",
          "creatures": "生物"
        },
        "resources": "资源",
        "moonsBadge": "卫星",
        "planets": "行星",
        "places": "地点",
        "showFewer": "收起",
        "showAll": "显示全部 %{count} 个",
        "elsewhere": "%{star} 周围的其他地方",
        "namesakes": "×%{count}",
        "lagrangePoints": "拉格朗日点",
        "inOrbit": "轨道上",
        "moons": {
          "one": "%{count} 颗卫星",
          "other": "%{count} 颗卫星"
        },
        "gateways": "跳跃门",
        "jumpPoints": "跳跃点",
        "notInGameYet": "尚未加入游戏",
        "jumpLegend": {
          "title": "跳跃连接",
          "inGame": "游戏中",
          "temporary": "临时",
          "planned": "计划中"
        },
        "systemStrip": "%{system}，从恒星向外",
        "allSystems": "所有星系",
        "allPlaces": "所有地点",
        "shops": "商店",
        "shopItems": {
          "one": "%{count} 件商品",
          "other": "%{count} 件商品"
        },
        "shopItemTypes": {
          "Model": "舰船",
          "ModelModule": "模块",
          "ModelPaint": "涂装",
          "Component": "组件",
          "Equipment": "装备",
          "Commodity": "商品"
        },
        "bodyTypes": {
          "gas_giant": "气态巨行星",
          "ice_giant": "冰巨星",
          "asteroid": "小行星",
          "city": "城市星球"
        },
        "unstable": "不稳定",
        "unstableHint": "耀星：其辐射会毫无预警地骤增。",
        "systems": "星系",
        "name": "名称",
        "kind": "类型",
        "retired": "不在此版本中",
        "starmap": "星图",
        "starmapVisibility": "游戏内地图",
        "starmapHidden": "在地图上隐藏",
        "starmapAlways": "始终显示在地图上",
        "starmapWithParent": "选中 %{parent} 后显示",
        "starmapShown": "显示在地图上",
        "quantumTravel": "量子旅行",
        "quantumTravelYes": "是",
        "quantumTravelNo": "否",
        "mapParent": "地图上位于",
        "mapParentNote": "游戏内地图将其显示在 %{mapParent} 下，但它实际位于 %{parent} 内。",
        "missions": "任务",
        "allMissions": "所有可在此进行的任务",
        "terminals": "交易终端",
        "alwaysShown": "始终在地图上",
        "hiddenOnStarmap": "在地图上隐藏",
        "facilities": "起降",
        "hangars": "机库",
        "hangarsNote": "每个机库按飞行员单独实例化：计数的是机库门，而非泊位。",
        "landingPads": "着陆平台",
        "freeLandingPads": "自由着陆平台",
        "freeLandingPadsNote": "无需 ATC 分配平台即可降落。",
        "vehiclePads": "地面载具平台",
        "dockingTubes": "对接舱口",
        "kinds": {
          "system": "星系",
          "star": "恒星",
          "planet": "行星",
          "moon": "卫星",
          "city": "城市",
          "spaceport": "太空港",
          "station": "空间站",
          "outpost": "前哨站",
          "clinic": "诊所",
          "district": "街区",
          "asteroid": "小行星",
          "anomaly": "异常点",
          "jump_point": "跳跃点",
          "point_of_interest": "兴趣点",
          "nav_point": "导航点",
          "other": "其他"
        },
        "setLocation": "设置位置",
        "myLocation": "我的位置",
        "shipLocation": "飞船位置",
        "setLocationSuccess": "位置已更新。",
        "setLocationFailure": "无法更新位置。"
      },
      "sortOptions": "排序选项",
      "loading": "加载中…",
      "loadingNamed": "正在加载 %{name}…",
      "true": "是",
      "false": "否",
      "null": "-",
      "presets": {
        "title": "选择图片",
        "filter": "类型",
        "all": "全部",
        "empty": "没有可用的图片。"
      },
      "maintainer": {
        "badge": "维护者",
        "tooltip": "维护 FleetYards.net"
      },
      "supporter": {
        "badge": "支持者",
        "tooltip": "本月正在支持 FleetYards.net",
        "none": "非支持者",
        "fleetTierUntil": "舰队等级至 %{date}",
        "fleetTierExpired": "已过期",
        "fleetTierOngoing": "订阅持续期间享有舰队等级",
        "until": "有效期至 %{date}",
        "expiring": "%{date} 到期",
        "ongoing": "定期支持，无结束日期",
        "tierShort": "第 %{tier} 级"
      },
      "destroyedFleets": {
        "discarded": "已丢弃",
        "purged": "已清除"
      },
      "and": "和",
      "hide": "隐藏",
      "show": "显示",
      "only": "仅",
      "description": "描述",
      "unavailable": "不可用",
      "selected": "已选择",
      "actions": "操作",
      "status": "状态",
      "enabled": "已启用",
      "disabled": "已禁用",
      "collapse": "折叠",
      "price": "价格",
      "expand": "展开",
      "distance": "距离",
      "anonymous": "匿名",
      "refreshing": "正在刷新...",
      "toggleNavigation": "切换导航",
      "openInNewWindow": "全屏打开",
      "or": "或",
      "groups": "分组",
      "classifications": "分类",
      "features": {
        "stateOn": "已启用",
        "stateOff": "已禁用",
        "stateConditional": "有条件",
        "openFor": "已开放 %{days} 天",
        "historyEmpty": "尚未记录此功能的任何变更。",
        "historyBy": "由 %{actor}",
        "sources": {
          "admin": "管理后台",
          "self_service": "自助",
          "sync": "部署",
          "console": "控制台",
          "backfill": "回填"
        },
        "selfService": "自助服务",
        "actors": "角色",
        "groups": "群组",
        "noGroups": "此功能没有启用的群组。",
        "noActors": "此功能没有启用的个人角色。",
        "user": "用户",
        "fleet": "舰队",
        "actorType": "角色类型",
        "percentageOfActors": "的角色",
        "percentageOfTime": "的时间",
        "currentState": "当前状态",
        "toggle": "切换",
        "permanent": "长期",
        "tabs": {
          "all": "全部",
          "rollout": "灰度发布",
          "permanent": "长期"
        },
        "settingsIntro": "为您的账户启用或禁用实验性功能。这些功能可能不完整或随时更改。",
        "registryHint": "功能标志在 config/feature_flags.yml 中声明，并在部署时创建。您可以在此控制它们的开放范围。",
        "fleetSettingsIntro": "为整个舰队启用或禁用功能。您在此启用的内容对所有成员可见。",
        "fleetFeature": "舰队功能",
        "fleetFeatureInfo": "在此启用仅对您生效。您舰队的管理员可为整个舰队启用。",
        "toggleForSelf": "仅为自己切换",
        "fleetFeatureGrantedShort": "舰队已启用",
        "fleetFeatureGranted": "您的舰队已为所有成员启用此功能，因此无法在此处关闭。",
        "groupFeatureGrantedShort": "群组已启用",
        "groupFeatureGranted": "您所在的某个群组已启用此功能，因此无法在此处关闭。",
        "groupFeatureGrantedFleet": "该舰队所在的某个群组已启用此功能，因此无法在此处关闭。",
        "managedFeatureShort": "受管理",
        "managedFeature": "此功能已为您的账户启用，无法在此处更改。",
        "managedFeatureFleet": "此功能已为该舰队启用，无法在此处更改。",
        "selfServiceUser": "用户可自行切换",
        "selfServiceFleet": "舰队管理员可切换",
        "globalHint": "开启后对所有人开放此功能。关闭会清除所有规则，包括下方的用户、舰队和分组。",
        "selfServiceHint": "谁可以自行开启此功能。",
        "lastChanged": "最后修改于 %{date}",
        "filterUsers": "按用户名筛选",
        "filterFleets": "按名称或 SID 筛选",
        "noUsers": "没有用户单独启用此功能。",
        "noFleets": "没有舰队单独启用此功能。",
        "noMatches": "没有符合筛选条件的结果。",
        "memberCount": "%{count} 名成员",
        "alreadyEnabled": "该舰队已启用此功能。"
      },
      "oauthApplication": {
        "name": "应用名称",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥",
        "redirectUri": "重定向 URI",
        "redirectUriHint": "每行一个 URI。",
        "confidential": "机密",
        "scopes": "权限范围",
        "scopesHint": "如果未选择权限范围，将使用默认范围: %{scopes}",
        "logo": "图标",
        "logoHint": "显示在授权页面上，方便用户辨认你的应用。支持 PNG、JPG、GIF 或 WebP。"
      },
      "rsiRequestLogs": {
        "resolved": "已解决",
        "unresolved": "未解决"
      },
      "imports": {
        "type": "类型",
        "status": "状态",
        "version": "版本",
        "startedAt": "开始于",
        "finishedAt": "完成于",
        "failedAt": "失败于",
        "info": "信息",
        "input": "输入",
        "output": "输出",
        "importData": "导入数据",
        "file": "已导入文件",
        "requestedBy": "请求者",
        "adminUser": "管理员用户",
        "user": "用户",
        "includeSystem": "包含系统",
        "systemRequester": "系统",
        "statuses": {
          "created": "排队中",
          "started": "运行中",
          "finished": "已完成",
          "failed": "已失败",
          "cancelled": "已取消"
        },
        "targetGroupHint": "选择一个机库分组，所有导入的舰船都会归入其中。留空则使用文件中指定的分组。",
        "types": {
          "Imports::HangarImport": "机库导入",
          "Imports::HangarSync": "RSI 机库同步"
        },
        "summary": {
          "imported": "已导入",
          "missing": "未找到",
          "found": "已匹配"
        },
        "formatHint": "支持两种文件格式：",
        "formats": {
          "fleetyards": "FleetYards 机库导出文件 —— 使用导出按钮即可生成。",
          "hangarXplor": "hangarXPLOR 导出文件。"
        },
        "details": {
          "imported": "已添加",
          "found": "已匹配",
          "movedToWanted": "已移至愿望单",
          "deleted": "已删除",
          "grouped": "已归入分组",
          "unchanged": "保持不变",
          "missing": "未找到的舰船",
          "missingComponents": "未找到的组件",
          "missingUpgrades": "未找到的升级"
        },
        "noDetails": "本次运行未记录详情。"
      },
      "oauthApplications": {
        "settingsIntro": "管理您的 OAuth 应用。这些应用可以代表用户访问 FleetYards API。",
        "name": "应用名称",
        "redirectUri": "重定向 URI",
        "confidential": "机密",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥",
        "scopes": "权限范围",
        "defaultScopes": "默认权限范围",
        "confidentialShort": "机密",
        "publicShort": "公开",
        "logo": "图标",
        "state": "状态",
        "rejectionReason": "拒绝原因",
        "statePending": "等待审核",
        "stateApproved": "已批准",
        "stateRejected": "已拒绝",
        "reviewedBy": "审核人",
        "owner": "注册者"
      },
      "fleetInviteToken": "舰队邀请",
      "inviteToken": "邀请码",
      "scDataVersion": "补丁版本",
      "title": "标题",
      "createdAt": "创建于",
      "updatedAt": "更新于",
      "addToHangar": "添加到机库",
      "home": {
        "search": "搜索飞船..."
      },
      "shop": {
        "sellPrice": "出售价格",
        "buyPrice": "购买价格"
      },
      "shopCommodity": {
        "item": "物品",
        "shop": "商店",
        "buyPrices": "买入价格",
        "rentalPrices": "租赁价格",
        "confirmed": "已确认?",
        "prices": {
          "label": "价格",
          "sellPrice": "售价",
          "buyPrice": "买入价"
        }
      },
      "statsCard": {
        "more": "详情页另有 %{count} 项",
        "unavailable": "无法加载这些详情。",
        "loading": "正在加载 %{name}…",
        "offeredBy": "由 %{name} 提供",
        "rsiHandle": "RSI 用户名 %{handle}",
        "types": {
          "Component": "组件",
          "Equipment": "装备",
          "Commodity": "商品",
          "Model": "舰船",
          "Blueprint": "蓝图",
          "GameMission": "任务",
          "Location": "地点",
          "FleetContract": "合约",
          "FleetEvent": "活动",
          "User": "用户",
          "FleetMember": "成员"
        },
        "open": {
          "Component": "打开组件",
          "Equipment": "打开装备",
          "Commodity": "打开商品",
          "Model": "打开舰船",
          "Blueprint": "打开蓝图",
          "GameMission": "打开任务",
          "Location": "打开地点",
          "FleetContract": "打开合约",
          "FleetEvent": "打开活动",
          "User": "打开机库",
          "FleetMember": "在成员列表中查看"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "%{year} 新飞船",
          "totalShips": "总飞船数",
          "totalMembers": "总成员数",
          "vehicles": "机库飞船",
          "wishlists": "愿望清单飞船",
          "shipOfTheMonth": "月度飞船"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "每月机库飞船",
        "topVehiclesByModel": "前 10 机库飞船",
        "shipsOfTheMonth": "月度飞船",
        "trendingShips": "浏览最多的飞船（30 天）",
        "wishlistByModel": "最受期待的飞船",
        "wishToOwnRatio": "每 100 艘拥有对应的期待数",
        "topPaints": "最受欢迎的涂装",
        "paintedVehicles": "已涂装飞船",
        "pledgePriceChanges": "现金购买价变动（12 个月）",
        "ingamePriceChanges": "游戏内价格变动（30 天）",
        "mostWishlisted": "本月最受期待的飞船",
        "patchChanges": "本次更新改动最大的飞船",
        "crewDeficit": "船员缺口",
        "crewSurplus": "船员盈余",
        "membersByRole": "按角色分组成员",
        "csv": {
          "metric": "指标",
          "value": "数值",
          "count": "数量"
        }
      },
      "roadmap": {
        "releases": "发布",
        "released": "已发布",
        "lastVersion": {
          "active": {
            "false": "条目已从路线图移除",
            "true": "条目已重新添加到路线图"
          },
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "unknown": "未知",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "名称",
      "homepage": "主页",
      "discord": "Discord 服务器",
      "youtube": "Youtube 频道",
      "twitch": "Twitch 频道",
      "guilded": "Guilded 服务器",
      "3dView": "3D",
      "3dMap": "Map",
      "texturedHolo": "纹理",
      "viewInAr": "AR",
      "viewInArHint": "以真实尺寸放置在你的房间中",
      "filter": "筛选",
      "taxExcluded": "不含增值税",
      "hangar": "机库",
      "public": "公开",
      "hangarStats": "统计",
      "wishlist": "愿望清单",
      "fleetchart": "舰队图表",
      "fleetchartScale": "舰船比例",
      "fleetchartApp": {
        "screenHeight": "屏幕高度",
        "viewpoint": "视角",
        "screenHeightOptions": {
          "auto": "自动",
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "port": "左舷",
          "top": "顶部",
          "angled": "斜角",
          "front": "正面"
        },
        "gridSize": "每格 %{size} 米",
        "mode": "模式",
        "modeOptions": {
          "classic": "经典",
          "panzoom": "v2"
        }
      },
      "fleetStats": "统计",
      "hangarMetrics": {
        "total": "总计",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "机库 aUEC 价值",
        "totalCrew": "船员",
        "totalCargo": "总货物",
        "largestShip": "最大飞船",
        "smallestShip": "最小飞船",
        "averagePledgePrice": "平均质押价格",
        "flightReady": "可飞行",
        "uniqueModels": "独特型号",
        "manufacturerCount": "制造商",
        "missingClassifications": "缺失角色",
        "wishlistTotalMoney": "愿望清单质押价值",
        "wishlistTotalCredits": "愿望清单游戏内价值"
      },
      "selectModel": "选择飞船",
      "findModel": "输入以查找飞船",
      "find": "输入以搜索",
      "selectUser": "选择用户",
      "findUser": "输入以搜索用户",
      "selectAdminUser": "选择管理员用户",
      "selectFleet": "选择舰队",
      "findFleet": "输入以搜索舰队",
      "compare": {
        "removeModel": "移除飞船",
        "addModel": {
          "nullablePrompt": "添加飞船"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} 飞船",
          "other": "%{count} 飞船"
        },
        "containersOfSize": "%{size} SCU 集装箱",
        "armorHp": "装甲 HP",
        "fuelAndQuantum": "燃料与量子",
        "weaponPoolSize": "武器能量池",
        "crossSection": {
          "x": "横截面 X",
          "y": "横截面 Y",
          "z": "横截面 Z"
        },
        "useAsBaseline": "用作基准",
        "baseline": "基准",
        "differencesOnly": "仅显示差异",
        "compareToBaseline": "与基准比较",
        "loadoutBySlot": "按挂点分组的配置",
        "slots": {
          "guns": "主炮",
          "turrets": "炮塔",
          "missiles": "导弹",
          "shields": "护盾发生器",
          "powerPlants": "发电机",
          "coolers": "散热器",
          "quantumDrives": "量子引擎",
          "thrusters": "主推进器",
          "countermeasures": "干扰弹"
        },
        "legend": {
          "best": "本行最佳",
          "worst": "最差",
          "share": "占本行最佳的比例",
          "better": "优于基准",
          "worse": "落后于基准"
        },
        "selectShips": "选择飞船"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "卖出",
      "buy": "买入",
      "yourFlagship": "您的旗舰",
      "flagship": "旗舰",
      "fleet": {
        "headquarters": "总部",
        "index": "舰队",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "舰队",
        "fid": "舰队 ID",
        "name": "名称",
        "logo": "标志",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "舰队 ID 是你的舰队在 Fleetyards 上的地址。SID 将舰队与其 RSI 组织关联，验证它可以证明该组织属于你。"
        },
        "fidClaim": {
          "claimableTitle": "申领舰队 ID %{fid}",
          "claimable": "你的舰队已通过 RSI 组织 %{fid} 的验证，但舰队 ID %{fid} 由另一支舰队持有。申领后，该舰队有 14 天时间自行证明该组织或通知其成员。之后它将被改名，%{fid} 成为你的舰队 ID。",
          "pendingTitle": "对 %{fid} 的申领进行中",
          "pending": "%{holder} 将保留 %{fid} 至 %{date}。之后该 ID 转给你的舰队，除非该舰队在此之前证明它在管理组织 %{fid}。",
          "availableTitle": "舰队 ID %{fid} 空闲",
          "available": "你的舰队已通过 %{fid} 的验证，且没有其他舰队使用该 ID。请在上方将其设为你的舰队 ID。",
          "incomingTitle": "%{claimant} 申领你的舰队 ID",
          "incoming": "%{claimant} 已通过 RSI 组织 **%{fid}** 的验证。\n\n**%{date}：**\n\n- 你的舰队将改用下一个空闲舰队 ID，例如 **%{fid}-1**。\n- 此后指向 %{fid} 的链接会打开 %{claimant}。\n\n**如需保留该 ID**，请在此之前验证 %{fid}；否则请通知你的成员地址即将变更。",
          "createTakenTitle": "%{fid} 已被占用",
          "createTaken": "如果 %{fid} 是你的 RSI 组织，请先使用 %{suggestion} 并填写 SID %{fid}。你的舰队通过 %{fid} 的验证后，即可从持有该 ID 的舰队申领它。"
        },
        "rsiVerification": {
          "extension": {
            "title": "使用 FleetYards Sync 扩展验证",
            "verify": "使用扩展验证",
            "description": "扩展会将验证码添加到你的组织在 RSI 上的历史中并发布，检查页面，然后再将验证码移除。",
            "detecting": "正在查找 FleetYards Sync 扩展",
            "install": "安装 FleetYards Sync 扩展，即可一键验证你的舰队。",
            "update": "更新 FleetYards Sync 扩展即可一键验证你的舰队：当前安装的版本尚不支持。",
            "notSignedIn": "请在此浏览器中使用可以编辑 %{sid} 的账户登录 RSI，或在下方手动验证。",
            "noRights": "此浏览器登录的 RSI 账户无法编辑 %{sid} 的页面。请使用军官账户登录，或在下方手动验证。",
            "pendingChanges": "%{sid} 在 RSI 上有未发布的更改。请先发布或清除该草稿，以免扩展发布他人的修改，或在下方手动验证。",
            "orgUnreadable": "扩展无法读取 %{sid} 在 RSI 上的页面。请在下方手动验证。",
            "failed": "扩展无法更新 %{sid} 的页面。请重试，或在下方手动验证。",
            "removeFailed": "扩展无法从 %{sid} 的历史中移除验证码。请在那里手动移除。",
            "manual": "或手动验证："
          },
          "steps": {
            "copy": "复制你的验证码",
            "paste": "将它粘贴到你的组织 RSI 公开页面的任意位置：简介、历史、宣言或章程。舰队验证后即可将其删除。",
            "check": "检查页面"
          },
          "openOrgPage": "在 RSI 上打开 %{sid}",
          "fidAtRiskTitle": "你的舰队 ID 未受保护",
          "saveFirst": "请先保存 SID 再进行验证。",
          "title": "RSI 验证",
          "token": "验证码",
          "verified": "已验证的 RSI 组织",
          "unverified": "未通过 RSI 验证",
          "verifiedSince": "自 %{date} 起已验证",
          "nextCheck": "一分钟后可以再次检查。",
          "fidAtRisk": "验证 RSI 组织 %{fid} 的另一支舰队可以认领它，你的舰队地址将会改变。",
          "statuses": {
            "pending": "正在检查组织页面…",
            "token_missing": "组织页面上还没有该验证码。RSI 可能需要几分钟才会显示修改。",
            "symbol_mismatch": "RSI 返回的页面属于另一个组织。",
            "not_found": "RSI 上没有使用此 SID 的组织。",
            "failed": "无法检查组织页面。请一分钟后重试。"
          }
        },
        "description": "描述",
        "public": "公开舰队视图",
        "publicFleet": "公开舰队",
        "publicStats": "公开统计",
        "publicFleetStats": "公开舰队统计",
        "discord": {
          "url": "Discord 服务器",
          "hint": "连接一个 Discord 服务器，将活动同步为原生的预定活动。成员可以在 Discord 中回复出席，报名会同步回 Fleetyards。",
          "guildId": "Discord 服务器 ID",
          "channelId": "语音频道 ID（可选）",
          "webhookUrl": "公告 Webhook URL（可选）",
          "installBotHint": "在新标签页中打开 Discord 安装页面 — 选择您希望同步活动的服务器。",
          "announcementChannel": "公告频道",
          "announcementChannelHint": "新活动和即将开始的提醒会发布在这里。未设置时通过 Webhook 发送。仅限中队的活动会改为发布在对应中队的频道中。",
          "officersChannel": "军官频道",
          "officersChannelHint": "仅军官可见的活动会在这里公告，不会出现在 Discord 的其他地方。未设置时不会在 Discord 上公告。加入申请也会发布在这里，并附有接受或拒绝的按钮。",
          "digestWeekday": "每周摘要",
          "digestWeekdayHint": "每周一次，每个频道会收到它可见的未来七天活动列表。留空即可关闭。",
          "digestTime": "摘要时间",
          "digestTimeHint": "使用你的时区（%{timezone}）。",
          "channelMissing": "该频道在 Discord 上已不存在或无法再发帖。选择其他频道之前不会发布任何内容。",
          "missingChannel": "不可用的频道",
          "joinRole": "加入身份组",
          "joinRoleHint": "在服务器中拥有此身份组的玩家无需申请即可加入舰队，并获得默认职级。移除该身份组后，通过它加入的成员也会被移出舰队。留空则手动审批每个申请。",
          "roleMissing": "此身份组在 Discord 上已不存在。在选择其他身份组之前，任何人都无法通过它加入。",
          "missingRole": "不可用的身份组",
          "saveGuildFirst": "请先保存新的服务器，然后再选择它的频道和身份组。",
          "roleMapping": "Discord 身份组",
          "roleMappingHint": "Fleetyards 会在服务器中给成员分配这些身份组，并在成员变更军衔或离开舰队时收回。它只会添加或移除这里选择的身份组。",
          "memberRole": "成员身份组",
          "memberRoleHint": "舰队的每位成员都会获得此身份组，与军衔无关。",
          "rolesCodes": {
            "missing_manage_roles": "机器人无权在此服务器中管理身份组。请使用安装链接重新授权。",
            "unknown_role": "这里选择的身份组在 Discord 上已不存在：%{names}。",
            "role_above_bot": "机器人无法分配 %{names}：Discord 只允许它分配低于自身的身份组。请在服务器设置中将机器人的身份组移到它们之上。"
          },
          "postingCodes": {
            "missing_send_messages": "机器人无权在此服务器发送消息。请通过安装链接重新授权。",
            "channel_locked": "机器人无法在为 %{names} 选择的频道中发帖。请在该频道的权限中允许。",
            "unknown_channel": "为 %{names} 选择的频道在 Discord 上已不存在或无法再发帖。",
            "channel_shared": "%{names} 与看不到其活动的读者共用一个频道。在各自拥有独立频道之前，不会在那里发布任何内容。"
          },
          "joinRoleCodes": {
            "members_intent_missing": "Fleetyards 机器人暂时无法列出此服务器的成员，因此加入身份组只在玩家使用邀请链接时生效。请联系管理员。",
            "live_updates_off": "身份组变更每天只同步到 Fleetyards 一次：机器人没有实时监听这些变更。请联系管理员。",
            "bot_offline": "Fleetyards 机器人目前未连接到 Discord，因此身份组变更会等到每日同步时处理。请联系管理员。"
          },
          "statusOk": "已连接到 %{name}",
          "statusCodes": {
            "missing_token": "服务器端未配置 Fleetyards 机器人。请联系管理员。",
            "missing_guild": "请先输入 Discord 服务器 ID。",
            "invalid_token": "机器人令牌无效。请联系管理员。",
            "bot_not_in_guild": "机器人不在该服务器中。请使用安装链接将其添加进去。",
            "guild_not_found": "Discord 无法识别此服务器 ID。请仔细核对该值。",
            "discord_error": "Discord 返回了意外的错误。",
            "request_failed": "无法连接到 Fleetyards。请重试。"
          }
        },
        "guilded": "Guilded 服务器",
        "homepage": "主页",
        "twitch": "Twitch 频道",
        "youtube": "Youtube 频道",
        "backgroundImage": "背景图片",
        "ts": "Teamspeak 服务器",
        "awaitingConfirmation": "等待舰队确认",
        "members": {
          "verifiedOrgMember": "%{sid} 的已验证成员",
          "verifiedOrgMemberChecked": "%{sid} 的已验证成员，检查于 %{checked}",
          "primary": "主舰队?",
          "shipsFilter": {
            "label": "哪些飞船应该添加到舰队?",
            "nullablePrompt": "未选择选项",
            "field": "飞船选择",
            "values": {
              "all": "所有飞船",
              "hangar_group": "指定机库群组中的所有飞船",
              "hide": "无飞船"
            }
          },
          "hangarGroupId": {
            "field": "机库群组",
            "label": "指定机库群组",
            "nullablePrompt": "未选择群组"
          },
          "blueprintsFilter": {
            "label": "哪些蓝图应与舰队共享？",
            "nullablePrompt": "未选择任何选项",
            "field": "蓝图选择",
            "values": {
              "all": "我拥有的全部蓝图",
              "hide": "不共享蓝图"
            }
          },
          "total": "总计: %{count}",
          "rsiTotal": "RSI 上: %{count}",
          "joined": "加入于",
          "invited": "已邀请",
          "invitedAt": "邀请/请求于",
          "requested": "已请求加入",
          "declined": "已拒绝",
          "pending": "待处理的邀请与请求",
          "accepted": "成员",
          "role": "角色",
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "成员",
            "invites": "邀请"
          },
          "health": {
            "overview": "检查项",
            "summary": {
              "attention": {
                "one": "%{total} 项检查中有 %{count} 项需要处理",
                "other": "%{total} 项检查中有 %{count} 项需要处理"
              },
              "clear": "全部 %{total} 项检查均正常"
            },
            "groups": {
              "leadership": "领导层",
              "rsi": "RSI 组织",
              "activity": "活跃度",
              "requests": "申请与邀请",
              "integrations": "集成"
            },
            "days": {
              "one": "%{count} 天",
              "other": "%{count} 天"
            },
            "checks": {
              "admins": {
                "title": "管理员",
                "overview": "管理员",
                "clear": "%{admins} 名成员担任管理员。"
              },
              "unverified": {
                "title": "未通过 %{sid} 验证",
                "overview": "未验证",
                "description": "当成员自己的 RSI 组织列表包含 %{sid} 时即视为已验证。每一行说明了无法确认的原因。",
                "clear": "所有成员都已通过 %{sid} 验证。"
              },
              "noHandle": {
                "title": "没有 RSI 账号名",
                "overview": "没有 RSI 账号名",
                "clear": "所有成员都填写了 RSI 账号名。"
              },
              "inactive": {
                "title": "不活跃成员",
                "overview": "%{count}+ 天不活跃",
                "clear": "所有人在过去 %{count} 天内都有活动。"
              },
              "joinRequests": {
                "title": "等待超过一周的入队申请",
                "overview": "旧入队申请",
                "clear": "没有入队申请等待超过一周。"
              },
              "invitations": {
                "title": "无人回应的邀请",
                "overview": "未回应的邀请",
                "clear": "没有邀请超过两周未处理。"
              },
              "inviteUrls": {
                "title": "需要整理的邀请链接",
                "overview": "邀请链接",
                "clear": "所有邀请链接都在使用中。"
              },
              "discord": {
                "title": "未关联 Discord",
                "overview": "Discord",
                "clear": "所有成员都已关联 Discord。"
              },
              "emptySquadrons": {
                "title": "无人加入的中队",
                "overview": "空中队",
                "clear": "每个中队都有成员。"
              },
              "noSquadron": {
                "title": "未加入中队的成员",
                "overview": "无中队",
                "clear": "所有成员都在中队中。"
              },
              "hiddenShips": {
                "title": "未纳入舰队的舰船",
                "overview": "隐藏的机库",
                "clear": "所有成员都与舰队共享其舰船。"
              }
            },
            "facts": {
              "joined": "于 %{date} 加入",
              "lastActive": "最后活动于%{distance}",
              "neverActive": "从未活动",
              "checked": "检查于%{distance}",
              "requested": "申请于%{distance}",
              "invited": "邀请于%{distance}",
              "invitedBy": "由 %{name} 邀请",
              "noDiscord": "未关联 Discord 账户",
              "noSquadron": "无中队",
              "noHandle": "未填写账号名",
              "linkExpired": "已于%{distance}过期",
              "linkUsedUp": "无剩余次数",
              "createdBy": "由 %{name} 创建",
              "used": {
                "one": "已使用 1 次",
                "other": "已使用 %{count} 次"
              },
              "team": "小组",
              "created": "创建于 %{date}",
              "linkUnused": "从未使用，创建于%{distance}"
            },
            "gaps": {
              "no_handle": "个人资料中没有 RSI 账号名",
              "handle_unverified": "RSI 账号名未验证",
              "orgs_not_checked": "尚未读取组织列表",
              "org_not_listed": "其组织列表中没有 %{sid}"
            },
            "orgStats": {
              "rsi": "%{sid} 在 RSI 上",
              "roster": "在 FleetYards 上",
              "gap": "从未在此加入"
            },
            "fleetNotVerified": "%{sid} 本身尚未验证，因此其他地方不会将任何成员显示为已验证。",
            "singleAdmin": "如果 %{name} 离开或失去访问权限，将没有人能在 FleetYards 上管理 %{fleet}。",
            "hiddenShips": {
              "one": "%{count} 名成员未将机库纳入舰队舰船列表。",
              "other": "%{count} 名成员未将机库纳入舰队舰船列表。"
            },
            "deleteLinkFailed": "无法删除该邀请链接。",
            "noAdmin": "没有人担任管理员，因此没有人能在 FleetYards 上管理 %{fleet}。",
            "adminCandidates": "提升为管理员",
            "addedToSquadron": {
              "success": "已加入中队。",
              "failure": "无法加入中队。"
            },
            "reminded": {
              "success": "提醒已发送。",
              "failure": "无法发送提醒。"
            },
            "remindedAt": "已于%{distance}提醒。一周后可再次提醒。"
          },
          "card": {
            "verified": "已验证",
            "unverified": "未验证",
            "squadrons": "中队"
          }
        },
        "squadrons": {
          "index": "中队",
          "name": "名称",
          "shortDescription": "简短描述",
          "shortDescriptionHint": "一两行，显示在卡片上",
          "description": "描述",
          "descriptionHint": "中队页面上的完整文字",
          "noDescription": "尚未添加描述。",
          "icon": "图标",
          "iconHint": "正方形图片，以圆形显示",
          "team": "小队",
          "teamHint": "小队对所有人开放；否则成员只能属于一个中队",
          "restrictedToHint": "只有这些中队可见",
          "discordChannel": "Discord 频道",
          "discordChannelHint": "仅限此中队的活动会在这里公告，不会出现在 Discord 的其他地方。未设置频道时不会在 Discord 上公告。",
          "notAnnounced": "%{names} 未设置 Discord 频道，不会在 Discord 上公告。",
          "blockedBy": "已在 %{squadron} 中队中",
          "color": "颜色",
          "colorSuggestions": "取自图标：",
          "memberCount": "%{count} 名成员",
          "members": "成员",
          "joinedAt": "加入中队时间",
          "searchMembers": "搜索成员",
          "availableMembers": "可添加的成员",
          "selectedMembers": "已选择 %{count} 位",
          "rank": "职级",
          "ranksHint": "本舰队所有中队使用的名称。重命名职级不会改变其位置和权限。",
          "rankName": "名称",
          "defaultRank": "默认",
          "defaultRankToggle": "新成员以此职级开始",
          "rankRights": {
            "singleHolder": "每个中队一名",
            "managesMembers": "可添加和移除职级低于自己的成员",
            "managesRanks": "可设置低于自己的职级"
          },
          "views": {
            "members": "成员",
            "requests": "申请"
          },
          "requestedAt": "申请时间",
          "requests": "申请"
        },
        "roles": {
          "permanent": "永久",
          "default": "默认",
          "defaultToggle": "新成员获得此角色",
          "privilegeGroups": {
            "fleet": "舰队",
            "memberships": "成员",
            "squadrons": "中队",
            "invites": "邀请",
            "vehicles": "载具",
            "blueprints": "蓝图",
            "roles": "角色",
            "inventories": "库存",
            "missions": "任务",
            "events": "活动",
            "allies": "盟友",
            "contracts": "合约",
            "payouts": "分账",
            "notifications": "通知",
            "announcements": "公告"
          },
          "privileges": {
            "fleet:update": "更新舰队",
            "fleet:update:images": "更新图片",
            "fleet:update:description": "更新描述",
            "fleet:delete": "删除舰队",
            "fleet:manage": "管理舰队",
            "fleet:memberships:read": "查看成员",
            "fleet:memberships:create": "邀请成员",
            "fleet:memberships:update": "更新成员",
            "fleet:memberships:delete": "移除成员",
            "fleet:memberships:manage": "管理成员",
            "fleet:squadrons:read": "查看中队",
            "fleet:squadrons:create": "创建中队",
            "fleet:squadrons:update": "编辑中队",
            "fleet:squadrons:delete": "删除中队",
            "fleet:squadrons:members:manage": "管理中队成员",
            "fleet:squadrons:manage": "管理中队",
            "fleet:invites:read": "查看邀请",
            "fleet:invites:create": "创建邀请",
            "fleet:invites:update": "更新邀请",
            "fleet:invites:delete": "删除邀请",
            "fleet:invites:manage": "管理邀请",
            "fleet:vehicles:read": "查看载具",
            "fleet:vehicles:create": "添加载具",
            "fleet:vehicles:update": "更新载具",
            "fleet:vehicles:delete": "移除载具",
            "fleet:vehicles:manage": "管理载具",
            "fleet:blueprints:read": "查看蓝图",
            "fleet:roles:read": "查看角色",
            "fleet:roles:create": "创建角色",
            "fleet:roles:update": "更新角色",
            "fleet:roles:delete": "删除角色",
            "fleet:roles:manage": "管理角色",
            "fleet:inventories:read": "查看库存",
            "fleet:inventories:create": "创建库存",
            "fleet:inventories:update": "更新库存",
            "fleet:inventories:delete": "删除库存",
            "fleet:inventories:manage": "管理库存",
            "fleet:missions:read": "查看任务",
            "fleet:missions:create": "创建任务",
            "fleet:missions:update": "更新任务",
            "fleet:missions:delete": "删除任务",
            "fleet:missions:manage": "管理任务",
            "fleet:events:read": "查看活动",
            "fleet:events:create": "创建活动",
            "fleet:events:update": "更新活动",
            "fleet:events:delete": "删除活动",
            "fleet:events:manage": "管理活动",
            "fleet:allies:read": "查看盟友",
            "fleet:allies:create": "添加盟友",
            "fleet:allies:delete": "移除盟友",
            "fleet:allies:manage": "管理盟友",
            "fleet:contracts:read": "查看合约",
            "fleet:contracts:create": "创建合约",
            "fleet:contracts:update": "更新合约",
            "fleet:contracts:delete": "删除合约",
            "fleet:contracts:manage": "管理合约",
            "fleet:payouts:read": "查看分账",
            "fleet:payouts:create": "记录分账",
            "fleet:payouts:update": "更新分账",
            "fleet:payouts:delete": "删除分账",
            "fleet:payouts:manage": "管理分账",
            "fleet:notifications:manage": "管理通知设置",
            "fleet:announcements:manage": "管理公告"
          },
          "name": "名称",
          "rank": "等级"
        },
        "inviteUrls": {
          "noExpiration": "Never expires",
          "used": "已使用 %{count} 次",
          "usedOfLimit": "已使用 %{count} / %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 天",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "生成一个私有链接，成员可以用它在日历应用（Apple 日历、Google 日历、Outlook）中订阅本舰队的活动。",
          "howTo": "将上面的链接分享给您的成员。他们把它粘贴到日历应用中（“订阅日历”或“通过 URL 添加”）。该链接是私有的 — 任何拿到它的人都能看到本舰队的活动。"
        },
        "notifications": {
          "inAppHint": "选择哪些活动状态变更会以应用内通知的形式推送给舰队成员。",
          "events": {
            "fleet_event": {
              "published": "活动已发布",
              "locked": "报名已锁定",
              "unlocked": "报名已重新开放",
              "starting_soon": "活动即将开始",
              "started": "活动已开始",
              "completed": "活动已完成",
              "cancelled": "活动已取消",
              "archived": "活动已归档",
              "destroyed": "活动已删除"
            },
            "fleet_event_signup": {
              "created": "新增报名",
              "withdrawn": "报名已取消"
            }
          }
        },
        "inventories": {
          "name": "名称",
          "description": "描述",
          "location": "位置",
          "visibility": "可见性",
          "manager": "管理者",
          "itemsCount": "条目数",
          "visibilities": {
            "members_only": "仅成员",
            "officers_only": "仅军官",
            "squadron_only": "仅中队"
          }
        },
        "allies": "盟友可见舰船",
        "alliesStats": "盟友可见统计",
        "alliesMembers": "盟友可见成员列表",
        "squadronsEnabled": "使用中队",
        "listed": "在舰队目录中显示",
        "listedInfo": "已验证、公开且至少有两名成员的舰队会出现在舰队目录中。私有舰队永远不会被列出。",
        "alignment": "阵营",
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "非法"
        },
        "activities": {
          "bounty_hunting": "赏金狩猎",
          "engineering": "工程",
          "exploration": "探索",
          "freelancing": "自由职业",
          "infiltration": "渗透",
          "medical": "医疗",
          "piracy": "海盗",
          "resources": "资源",
          "scouting": "侦察",
          "security": "安保",
          "smuggling": "走私",
          "social": "社交",
          "trading": "贸易",
          "transport": "运输"
        },
        "commitments": {
          "casual": "休闲",
          "regular": "常规",
          "hardcore": "硬核"
        },
        "rsiProfile": {
          "info": "每天从你的组织的 RSI 页面同步一次。请在 RSI 上修改这些信息。",
          "primaryActivity": "主要活动",
          "secondaryActivity": "次要活动",
          "language": "语言",
          "commitment": "投入程度",
          "recruiting": "招募中",
          "roleplay": "角色扮演"
        },
        "contractCovers": {
          "transport": "运送封面图",
          "procurement": "采购封面图",
          "crafting": "制造封面图"
        }
      },
      "hangarGroup": {
        "name": "名称",
        "color": "颜色",
        "sort": "排序",
        "public": "在公开机库显示?"
      },
      "source": "来源",
      "loadout": {
        "marker": "配置“%{name}”",
        "fleetyards": "Fleetyards 配装",
        "namePlaceholder": "配置名称...",
        "urlPlaceholder": "粘贴 erkul.games 或 spviewer.eu 的配置链接...",
        "empty": "暂无配置。创建一个以开始使用。",
        "active": "使用中",
        "activate": "设为使用中"
      },
      "model": {
        "hidden": "隐藏?",
        "active": "活跃?",
        "inGame": "已实装?",
        "adiMap": "ADI 地图?",
        "ground": "地面载具?",
        "productionNote": "生产备注",
        "rsiId": "RSI ID",
        "length": "长度",
        "beam": "宽度",
        "height": "高度",
        "scKey": "SC Key",
        "price": "价格",
        "pledgePrice": "质押价格",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "质量",
        "crew": "船员",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "货物",
        "cargoHolds": "货舱",
        "keepCargo": "保留此货运数值，而不是使用游戏文件中的货舱",
        "hydrogenFuelTankSize": "氢燃料箱大小",
        "hydrogenFuelTanks": "氢燃料箱",
        "quantumFuelTankSize": "量子燃料箱大小",
        "quantumFuelTanks": "量子燃料箱",
        "externalFuelTanks": "外挂燃料箱",
        "orePods": "矿石舱",
        "weaponRacks": "武器架",
        "medicalBedsTier": "%{tier} 级医疗床",
        "medicalBedsNamed": "%{name}医疗床",
        "respawnBeds": "重生床位",
        "salvageStorage": "回收储存",
        "externalFuelTanksTotal": "总容量",
        "externalFuelTanksCount": "挂舱",
        "refuelBoom": "加油臂",
        "refuelBoomArm": "臂",
        "refuelBoomNozzle": "喷嘴",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增强）",
        "pitchBoosted": "俯仰（增强）",
        "rollBoosted": "翻滚（增强）",
        "variants": "变体",
        "manufacturer": "制造商",
        "loaners": "借用船",
        "paints": "涂装",
        "modules": "模块",
        "modulePackages": "模块包",
        "upgrades": "升级套件",
        "brochure": "手册",
        "holo": "Holo",
        "angledView": "斜视图",
        "angledViewColored": "斜视图（彩色）",
        "portView": "左舷视图",
        "portViewColored": "左舷视图（彩色）",
        "frontView": "前视图",
        "frontViewColored": "前视图（彩色）",
        "topView": "俯视图",
        "topViewColored": "俯视图（彩色）",
        "onSale": "在售",
        "playerOwnable": "玩家可拥有?",
        "ingameOnly": "仅游戏内获取",
        "canLandOnPlanets": "可在行星降落",
        "cannotLandOnPlanets": "无法在行星降落",
        "salesPage": "销售页面",
        "addons": "模块与升级套件",
        "storeImage": "商店图片",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "船员岗位",
        "needsCuration": "需人工校订",
        "curatedPosition": "人工校订的岗位",
        "baseModel": "基础型号",
        "fleetchartOffsetLength": "舰队图表长度偏移",
        "fleetchartOffsetBeam": "舰队图表宽度偏移",
        "extendedLength": "展开长度",
        "extendedBeam": "展开宽度",
        "extendedHeight": "展开高度",
        "extendedFleetchartOffsetLength": "展开舰队图偏移长度",
        "extendedFleetchartOffsetBeam": "展开舰队图偏移宽度",
        "defaultHolo": "默认全息图",
        "extendedHolo": "展开全息图",
        "extendedTopView": "展开俯视图",
        "extendedTopViewColored": "展开俯视图（涂装）",
        "extendedPortView": "展开左舷视图",
        "extendedPortViewColored": "展开左舷视图（涂装）",
        "extendedFrontView": "展开正视图",
        "extendedFrontViewColored": "展开正视图（涂装）",
        "extendedAngledView": "展开斜视图",
        "extendedAngledViewColored": "展开斜视图（涂装）",
        "landedHolo": "着陆全息图",
        "landedTopView": "着陆俯视图",
        "landedPortView": "着陆左舷视图",
        "landedFrontView": "着陆正视图",
        "landedAngledView": "着陆斜视图",
        "landedTopViewColored": "着陆俯视图（涂装）",
        "landedPortViewColored": "着陆左舷视图（涂装）",
        "landedFrontViewColored": "着陆正视图（涂装）",
        "landedAngledViewColored": "着陆斜视图（涂装）",
        "angledRearView": "后斜视图",
        "angledRearViewColored": "后斜视图（彩色）",
        "bottomView": "仰视图",
        "bottomViewColored": "仰视图（彩色）",
        "rearView": "后视图",
        "rearViewColored": "后视图（彩色）",
        "starboardView": "右舷视图",
        "starboardViewColored": "右舷视图（彩色）",
        "extendedAngledRearView": "展开后斜视图",
        "extendedAngledRearViewColored": "展开后斜视图（涂装）",
        "extendedBottomView": "展开仰视图",
        "extendedBottomViewColored": "展开仰视图（涂装）",
        "extendedRearView": "展开后视图",
        "extendedRearViewColored": "展开后视图（涂装）",
        "extendedStarboardView": "展开右舷视图",
        "extendedStarboardViewColored": "展开右舷视图（涂装）",
        "landedAngledRearView": "着陆后斜视图",
        "landedAngledRearViewColored": "着陆后斜视图（涂装）",
        "landedBottomView": "着陆仰视图",
        "landedBottomViewColored": "着陆仰视图（涂装）",
        "landedRearView": "着陆后视图",
        "landedRearViewColored": "着陆后视图（涂装）",
        "landedStarboardView": "着陆右舷视图",
        "landedStarboardViewColored": "着陆右舷视图（涂装）",
        "holoLite": "轻量全息图",
        "extendedHoloLite": "展开轻量全息图",
        "landedHoloLite": "着陆轻量全息图",
        "holoTextured": "纹理全息图",
        "state": {
          "flight": "飞行中",
          "extended": "展开",
          "landed": "着陆"
        },
        "productionStatus": {
          "in-production": "生产中",
          "in-concept": "概念阶段",
          "ready": "机库就绪",
          "flight-ready": "可飞行",
          "announced": "已公布"
        },
        "carriedBy": "可被搭载于",
        "landedLength": "着陆长度",
        "landedBeam": "着陆宽度",
        "landedHeight": "着陆高度",
        "landedFleetchartOffsetLength": "着陆舰队图长度偏移",
        "landedFleetchartOffsetBeam": "着陆舰队图宽度偏移",
        "owners": {
          "title": "你的圈子",
          "yourShips": "你的舰船",
          "friends": "好友",
          "fleets": "你的舰队",
          "more": "另外 %{count} 个",
          "empty": "你认识的人还没有拥有这艘舰船。",
          "fleetShips": {
            "one": "%{count} 艘舰船",
            "other": "%{count} 艘舰船"
          }
        }
      },
      "models": {
        "extraColumns": "列",
        "table": {
          "columns": {
            "storeImage": "图片",
            "storeImageWide": "宽图片",
            "rsiStoreImage": "RSI 图片",
            "rsiStoreImageWide": "宽 RSI 图片",
            "angledView": "3D 图片",
            "angledViewWide": "宽 3D 图片",
            "rsiId": "RSI ID",
            "hidden": "隐藏",
            "active": "活跃",
            "createdAt": "创建于",
            "updatedAt": "更新于",
            "manufacturerName": "制造商",
            "length": "长度",
            "beam": "宽度",
            "height": "高度",
            "mass": "质量",
            "cargo": "货物",
            "quantumFuelTankSize": "量子燃料",
            "hydrogenFuelTankSize": "氢燃料",
            "crew": "船员",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "最大速度",
            "groundMaxSpeed": "地面速度",
            "focus": "定位",
            "productionStatus": "生产状态",
            "price": "价格",
            "pledgePrice": "质押价格"
          }
        }
      },
      "metrics": {
        "info": "信息",
        "levels": "等级",
        "views": "视图",
        "base": "基础",
        "crew": "船员",
        "speed": "速度",
        "cargo": "货物",
        "combat": "战斗",
        "hardpoints": "挂载点"
      },
      "flight": {
        "boostCapacitor": "加力电容",
        "boostCapacity": "容量",
        "boostRegen": "恢复",
        "boostRegenDelay": "恢复延迟",
        "boostRamp": "升 / 降时间",
        "title": "飞行",
        "scm": "战斗巡航",
        "nav": "巡航",
        "boost": "加速",
        "boostSub": "加力燃烧",
        "reverse": "倒车",
        "maneuverability": "机动性",
        "fuel": "燃料",
        "fuelHydrogen": "氢",
        "fuelQuantum": "量子",
        "hint": "加速后的操控表现随引擎能量档位变化；引擎未通电时全部为零。"
      },
      "base": {
        "price": "价格",
        "priceInGame": "游戏内",
        "pricePledge": "质押",
        "availability": "供应情况"
      },
      "availability": {
        "title": "供应情况",
        "buy": "购买",
        "rent": "租赁",
        "sell": "出售",
        "cheapest": {
          "buy": "最低售价",
          "rent": "最低租金"
        },
        "bestSale": "最高收购价",
        "allLocations": "全部地点",
        "locations": {
          "one": "%{count} 个地点",
          "other": "%{count} 个地点"
        },
        "empty": "没有已知的购买或租赁地点。",
        "timeRange": {
          "1-day": "1 天",
          "3-days": "3 天",
          "7-days": "7 天",
          "30-days": "30 天"
        }
      },
      "cargo": {
        "title": "货物",
        "holdsSub": "分布于 %{count} 个货舱",
        "maxContainerSub": "可容纳的最大箱体",
        "containers": "集装箱容量",
        "hint": "每种尺寸的集装箱在货物网格中可容纳的最大数量；进度条显示其占总容量的比例。"
      },
      "weaponRacks": {
        "slots": "槽位",
        "racks": "武器架",
        "categories": {
          "weapon": "武器",
          "gadget": "小工具",
          "cargo": "货物",
          "carriable": "可携带物品",
          "armor": "护甲",
          "other": "其他"
        },
        "size": "S%{size}",
        "sizeRange": "S%{min}–S%{max}",
        "sizeUpTo": "最高 S%{size}",
        "only": "仅限%{tag}",
        "tags": {
          "multitool": "多功能工具",
          "medical_injection": "医疗笔",
          "grenade": "手雷"
        },
        "hint": "船上所有武器架的槽位，按可放置物品和尺寸分组。"
      },
      "storageContainers": {
        "total": "总容量",
        "count": "容器",
        "perContainer": "每个",
        "hintOre": "存放开采的矿石，不是货物。",
        "hintSalvage": "存放回收的材料，不是货物。"
      },
      "fuelTanks": {
        "capacitySub": "分布于 %{count} 个挂舱",
        "podsSub": "外部挂点",
        "components": "挂舱类型",
        "perPod": "每个挂舱",
        "hint": "挂载在外部挂点上的燃料舱所携带的燃料；进度条显示每种类型占总容量的比例。"
      },
      "refuelBoom": {
        "fuelFlowSub": "氢燃料传输",
        "quantumFlowSub": "量子燃料传输",
        "captureRadiusSub": "对接容差",
        "equipment": "装备",
        "hint": "加油臂的传输速率及其喷嘴的对接容差。"
      },
      "combat": {
        "title": "战斗",
        "openPenetrationCheck": "穿透检测",
        "dps": "爆发 DPS",
        "dpsSub": "%{count} 件武器",
        "sustained": "持续 DPS",
        "sustainedSub": "计入能量回复与过热",
        "alpha": "齐射伤害",
        "alphaSub": "每次齐射",
        "weapons": "武器",
        "missileDamage": "导弹伤害",
        "armedMissiles": "可武装导弹",
        "armedMissilesSub": "发射间隔 %{cooldown} 秒",
        "composition": "伤害构成",
        "damagePhysical": "物理",
        "damageEnergy": "能量",
        "damageDistortion": "扭曲",
        "damageThermal": "热能",
        "controlComposition": "按操控分类的DPS",
        "controlGroups": {
          "pilot": "驾驶员",
          "manned": "有人炮塔",
          "remote": "遥控炮塔",
          "pds": "点防御"
        },
        "hint": "数据来自默认配置的 DPS。持续 DPS 计入每件武器的能量池回复和过热循环。不含导弹。"
      },
      "power": {
        "title": "能量分配",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "重置",
        "auto": "自动",
        "aimAssist": "瞄准辅助",
        "cooling": "散热",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "点击切换轴（x / y / z）",
        "segmentsUsed": "%{used} / %{total} 格",
        "hint": "在各系统间分配能量。武器的持续 DPS 随其获得的能量变化；其余部分会自动平衡。",
        "families": {
          "weapon": "武器",
          "shield": "护盾",
          "engine": "引擎",
          "radar": "雷达",
          "coolers": "散热器",
          "qdrive": "量子引擎",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "生命维持",
          "miningLaser": "采矿激光",
          "salvage": "回收",
          "tractorBeam": "牵引光束",
          "towingbeam": "拖曳光束"
        }
      },
      "defense": {
        "title": "防御",
        "shieldHp": "护盾 HP",
        "shieldHpSub": "%{count} 台发生器",
        "shieldRegen": "回复",
        "shieldResistances": "抗性",
        "shieldAbsorption": "吸收",
        "shieldFaces": "护盾面",
        "armor": "装甲",
        "deflection": "偏转",
        "armorReduction": "伤害减免",
        "armorSelfResistance": "自身抗性",
        "armorSignature": "信号特征",
        "countermeasures": "干扰措施",
        "countermeasureDuration": "持续时间",
        "countermeasure": {
          "decoy": "诱饵弹",
          "noise": "干扰箔"
        },
        "damageType": {
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "热能"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "护盾、装甲与干扰措施数值来自默认配置。吸收率低于 100% 表示该伤害类型在护盾仍在时就能打到船体。",
        "openDeflectionCheck": "偏转检测"
      },
      "penetrationCheck": {
        "title": "穿透检测",
        "intro": "— 它的武器能击穿哪些舰船？",
        "noWeapons": "此配装没有可检测单发伤害的机炮。",
        "weapons": "武器",
        "shieldHealth": "目标护盾状态",
        "armorHealth": "目标装甲状态",
        "ship": "舰船",
        "hoverHint": "将鼠标悬停在舰船上查看各武器明细。",
        "note": "每门选中的机炮都按照与偏转检测相同的规则，与每艘舰船的护盾和装甲偏转进行比较；只要其中任意一门能够击穿，该舰船即视为被击穿，并按最接近阈值的机炮排序。没有装甲的舰船不在列表中，因为没有可跨越的阈值。",
        "sortBy": "排序方式",
        "sort": {
          "margin": "差值",
          "ttk": "击毁时间"
        },
        "ttk": "TTK",
        "effectiveHp": "有效生命值",
        "shieldsDown": "护盾击破",
        "ttkNote": "击毁时间使用所选机炮在当前能量分配下的持续每秒伤害，并从上方设定的护盾和装甲健康度开始计算。护盾承受其吸收的伤害（扣除抗性），其余伤害传给装甲；装甲承受伤害直至损毁，之后伤害传给船体。畸变伤害只会消耗护盾。只有当所有机炮的停火时间都超过护盾的再生延迟时，护盾才会再生；护盾一旦被击破便不再恢复。有效生命值是摧毁舰船所需的单一类型原始伤害，不计偏转。标有 TTK 的光束武器只计入击毁时间：装甲永远不会偏转它们，且由于没有单发伤害，它们不参与差值计算。导弹不计入。"
      },
      "deflectionCheck": {
        "title": "偏转检测",
        "intro": "— 哪些武器能击穿它的防御?",
        "noArmor": "这艘飞船没有装甲，因此不会发生偏转。",
        "allSizes": "全部",
        "deflected": "被偏转",
        "pierce": "可击穿",
        "weapon": "武器",
        "boundary": "偏转界限",
        "alpha": "单发伤害",
        "threshold": "已越过阈值",
        "absorbed": "被吸收",
        "versus": "对比",
        "hoverHint": "将鼠标悬停在武器上可查看按伤害类型的细分。",
        "note": "单发伤害按每颗弹丸计算，且在护盾吸收之后比较 — 只要某一伤害类型超过偏转值，该武器即可击穿。被护盾完全吸收的类型永远到不了装甲，因此列为被吸收而非被偏转: 挡下它的是护盾，不是船体。护盾吸收率会根据护盾耐久在其公布的最小-最大区间内插值，装甲偏转值则随装甲耐久线性变化。激光束不在统计之内 — 它造成持续伤害，没有可供比较的单发伤害。",
        "margin": "余量",
        "reachesArmor": "可达装甲",
        "stoppedByShields": "护盾吸收",
        "verdict": {
          "absorbed": "已吸收",
          "deflected": "已偏转",
          "pierces": "已击穿"
        },
        "shieldHealth": "护盾耐久",
        "armorHealth": "装甲耐久",
        "absorb": "吸收",
        "defl": "偏转",
        "type": "类型",
        "size": "尺寸"
      },
      "hull": {
        "category": {
          "vital": "关键",
          "secondary": "次要",
          "breakable": "可破坏",
          "subpart": "子部件",
          "cosmetic": "装饰"
        },
        "composition": "船体构成",
        "door": "舱门",
        "doors": "舱门",
        "doorsNote": "可破坏的内部舱门属于独立区域 — 它们有各自的耐久度，不计入船体 HP。",
        "doorsSub": "%{count} 个可破坏",
        "hint": "船体 HP 是所有部件耐久度的总和。",
        "hullHp": "船体 HP",
        "hullHpSub": "所有部件合计",
        "integrity": "船体完整度",
        "noHp": "无 HP",
        "parts": "船体部件",
        "partsNote": "部件按耐久度排序；装饰性部件（舱门、梯子、襟翼）本身没有耐久度。游戏文件未提供父子层级关系，因此这里是平铺列表而非结构树。",
        "partsSub": "分布于 %{count} 个类别",
        "partsTree": "部件 · damageMax",
        "showParts": "显示船体部件",
        "title": "船体",
        "totalHp": "船体总 HP"
      },
      "manufacturer": {
        "shortName": "简称",
        "shipyard": "船坞",
        "longName": "全名",
        "code": "代码",
        "logo": "标志",
        "logoOverridden": "标识（已覆盖）",
        "icon": "图标（游戏文件）",
        "iconOverridden": "图标（已覆盖）",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "标题",
        "body": "正文",
        "discordParts": "Discord 消息",
        "socialParts": "社交平台帖子",
        "link": "链接",
        "notifyUsers": "应用内通知",
        "postDiscord": "Discord 更新频道",
        "postBluesky": "Bluesky",
        "schedule": "定时发送",
        "publishAt": "发送时间"
      },
      "fundingGoal": {
        "title": "标题",
        "description": "描述",
        "amount": "金额",
        "currency": "货币",
        "effectiveFrom": "生效日期",
        "endedAt": "结束于"
      },
      "supporterContribution": {
        "name": "支持者名称",
        "user": "关联账户",
        "amount": "金额",
        "currency": "货币",
        "anonymous": "匿名",
        "recurring": "周期性",
        "startedAt": "开始于",
        "endedAt": "结束于",
        "payerEmail": "付款人邮箱",
        "claimKey": "支持者令牌",
        "linkedVia": "关联方式",
        "source": "来源",
        "note": "内部备注",
        "stats": {
          "total": "总计",
          "count": "捐助数",
          "currentMonth": "本月",
          "currentMonthCount": "%{count} 笔捐助",
          "recurringCount": "周期性",
          "anonymousCount": "匿名"
        },
        "chart": {
          "contributions": "捐助",
          "goal": "目标"
        }
      },
      "itemPrice": {
        "price": "价格",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "URL",
        "videoType": "类型"
      },
      "modelModule": {
        "slot": "槽位",
        "noSlot": "无槽位",
        "slotsOnHull": "此舰船的模块槽位：%{slots}",
        "noSlotsOnHull": "游戏文件没有为此舰船提供模块槽位；可以设置任意名称",
        "name": "名称",
        "description": "描述",
        "price": "价格",
        "pledgePrice": "承诺价格",
        "productionStatus": "生产状态",
        "scKey": "SC Key",
        "storeImage": "商店图片",
        "active": "激活？",
        "hidden": "隐藏？"
      },
      "dockAddition": {
        "model": "飞船",
        "hint": "该泊位可容纳但其类别未涵盖的飞船。",
        "empty": "已指定的飞船"
      },
      "dockCapacity": {
        "ladder": "等级序列",
        "size": "类别",
        "quantity": "数量",
        "display": "作为标签显示",
        "hint": "该泊位的用途。各条目为互选方案，而非累加。",
        "empty": "容量条目"
      },
      "dockCapacityLadders": {
        "ship": "飞船",
        "vehicle": "车辆"
      },
      "vehicleSizes": {
        "extra_extra_small": "超超小型 (XXS)",
        "extra_small": "超小型 (XS)",
        "small": "小型 (S)",
        "medium": "中型 (M)",
        "large": "大型 (L)",
        "extra_large": "超大型 (XL)",
        "extra_extra_large": "超超大型 (XXL)"
      },
      "dock": {
        "name": "名称",
        "dockType": "停靠类型",
        "shipSize": "飞船尺寸",
        "access": "进入方式",
        "length": "长度",
        "beam": "宽度",
        "height": "高度",
        "unmeasured": "未测量"
      },
      "modelPosition": {
        "name": "名称",
        "positionType": "岗位类型",
        "source": "来源",
        "position": "排序",
        "types": {
          "pilot": "飞行员",
          "copilot": "副驾驶",
          "turret_gunner": "炮塔射手",
          "engineer": "工程师",
          "gunner": "射手",
          "loadmaster": "装载员",
          "passenger": "乘客",
          "operator": "操作员",
          "custom": "自定义"
        }
      },
      "modelUpgrade": {
        "name": "名称",
        "description": "描述",
        "pledgePrice": "质押价格",
        "active": "活跃?",
        "hidden": "隐藏?"
      },
      "modelModulePackage": {
        "name": "名称",
        "description": "描述",
        "pledgePrice": "质押价格",
        "modules": "模块",
        "active": "活跃?",
        "hidden": "隐藏?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "旋转 (°)"
      },
      "modelLoaner": {
        "hidden": "隐藏?",
        "loanerModel": "借用型号"
      },
      "modelSnubCraft": {
        "snubCraft": "舰载小艇"
      },
      "modelPaint": {
        "hidden": "隐藏?",
        "active": "活跃?",
        "onSale": "在售",
        "pledgePrice": "质押价格",
        "productionStatus": "生产状态",
        "productionNote": "生产备注",
        "copyHint": "选择要将此涂装复制到的目标飞船。复制过程中不会修改涂装数据。",
        "bulkCopyHint": "选择要将这 %{count} 个涂装复制到的目标飞船。复制过程中不会修改涂装数据。",
        "copySameModel": "目标飞船必须与源飞船不同。"
      },
      "component": {
        "temperature": {
          "minCooling": "冷却起始",
          "overheat": "过热温度",
          "warning": "警告温度",
          "recovery": "恢复温度",
          "misfireRange": "故障温度范围",
          "irStart": "红外起始",
          "irPerKelvin": "每开红外"
        },
        "misfire": {
          "heat": "热量",
          "distortion": "扭曲",
          "damage": "损伤",
          "wear": "磨损",
          "window": "时间窗口",
          "hint": "游戏文件中给出的各项状态阈值，达到后组件可能开始发生故障。"
        },
        "availability": {
          "retired": "价格只针对目录当前所在的版本记录，而该部件不在其中。",
          "craftedOnly": "没有终端出售此物品——它由下方的配方制造。",
          "none": "没有终端买卖此物品。"
        },
        "notRecordedYet": "仅从开始记录之日起统计，因此部件可能尚无记录。",
        "size": "Size: %{size}",
        "grade": "等级",
        "hidden": "隐藏?",
        "componentType": "组件类型",
        "componentSubType": "组件子类型",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "类别",
        "category": "分类",
        "subType": "子类型",
        "retired": "已不在当前版本中",
        "noMetrics": "该部件没有记录任何数据。",
        "durability": {
          "health": "耐久",
          "mass": "质量",
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "热能",
          "biochemical": "生化",
          "stun": "眩晕",
          "repairTime": "修复时间",
          "repairsTo": "修复至",
          "maxRepairs": "最大修复次数",
          "disableAt": "失效阈值",
          "warningAt": "警告阈值",
          "recoversBelow": "恢复阈值",
          "decayRate": "衰减速率",
          "decayDelay": "衰减延迟"
        },
        "durabilityChanges": {
          "health": "耐久",
          "mass": "质量 (kg)",
          "resistancesPhysical": "承受物理伤害",
          "resistancesEnergy": "承受能量伤害",
          "resistancesDistortion": "承受扭曲伤害",
          "resistancesThermal": "承受热能伤害",
          "resistancesBiochemical": "承受生化伤害",
          "resistancesStun": "承受眩晕伤害",
          "selfRepairTime": "自我修复时间 (s)",
          "selfRepairHealthRatio": "自我修复恢复至",
          "selfRepairMaxRepairs": "最大自我修复次数",
          "distortionMaximum": "扭曲失效阈值",
          "distortionWarningRatio": "扭曲警告阈值",
          "distortionRecoveryRatio": "扭曲恢复阈值",
          "distortionDecayRate": "扭曲衰减速率 (/s)",
          "distortionDecayDelay": "扭曲衰减延迟 (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "图例",
          "slotTaken": "插槽已占用",
          "slotAvailable": "插槽可用"
        },
        "size": "尺寸",
        "rackSize": "架尺寸",
        "details": "详情",
        "group": "群组",
        "thrusters": {
          "thrust": "推力",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "fuelBurn": "燃料消耗",
          "mode": "模式",
          "vtolOnly": "仅限垂直起降",
          "vectorPitch": "推力矢量俯仰",
          "vectorYaw": "推力矢量偏航"
        },
        "refuelBoom": {
          "captureRadius": "捕获半径",
          "fuelFlowRate": "燃料流速",
          "quantumFuelFlowRate": "量子燃料流速"
        },
        "controllers": {
          "faceType": "护盾类型",
          "faces": {
            "bubble": "气泡",
            "quadrant": "四象限"
          },
          "reconfigurationCooldown": "重新分配",
          "armedMissiles": "可武装导弹",
          "launchCooldown": "发射冷却",
          "lockAngle": "锁定角度"
        },
        "countermeasureStats": {
          "duration": "持续时间",
          "spawnDelay": "展开延迟",
          "infrared": "红外信号",
          "electromagnetic": "电磁信号",
          "crossSection": "截面信号"
        },
        "turrets": {
          "turnRate": "转向速率",
          "control": "操控",
          "yawRange": "偏航范围",
          "pitchRange": "俯仰范围",
          "limitsVary": "随转向变化",
          "gunPorts": "武器接口"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "爆发 DPS",
          "sustainedDps": "持续 DPS",
          "efficiency": "效率",
          "penetration": "穿透",
          "fireRate": "射速",
          "speed": "速度",
          "range": "射程",
          "ammo": "弹药",
          "ammoCost": "弹药成本",
          "magazineDamage": "弹匣总伤害",
          "timeToEmpty": "打空时间",
          "spread": "散布",
          "spreadFirstShot": "首发散布",
          "spreadPerShot": "散布/发",
          "spreadRecovery": "散布恢复",
          "pool": "能量池",
          "maxRegen": "最大回复/秒",
          "costPerShot": "能量/发",
          "heatPerShot": "热量/发",
          "heatPerSecond": "热量/秒",
          "gimbalFireRate": "射速（万向）",
          "gimbalSpread": "散布（万向）",
          "spreadMin": "最小",
          "spreadMax": "最大",
          "aimAssist": "瞄准辅助",
          "closeAimAssist": "近距离瞄准辅助",
          "chargeTime": "充能时间",
          "fullDamageRange": "满伤射程",
          "zeroDamageRange": "零伤射程",
          "damagePhysical": "物理",
          "damageEnergy": "能量",
          "damageDistortion": "扭曲",
          "damageThermal": "热能"
        },
        "missiles": {
          "damage": "伤害",
          "speed": "速度",
          "range": "射程",
          "lockRange": "锁定距离",
          "lockTime": "锁定时间",
          "trackingSignal": "追踪",
          "lockAngle": "锁定锥角",
          "signalResilience": "信号抗性",
          "boostPhase": "助推阶段",
          "terminalPhase": "末段",
          "lifetime": "存续时间",
          "fuel": "燃料",
          "dumbfire": "无制导发射",
          "dumbfireAllowed": "允许",
          "dumbfireBlocked": "不允许",
          "blastRadius": "爆炸半径",
          "armTime": "引信解锁时间",
          "safetyDistance": "安全距离"
        },
        "bombs": {
          "maxDropAngle": "最大投弹角"
        },
        "missileRacks": {
          "launchDelay": "发射间隔",
          "ignition": "发动机点火",
          "ignitesOnRack": "在挂架上",
          "ignitesAfterRelease": "释放后"
        },
        "tractorBeams": {
          "maxForce": "最大牵引力",
          "minForce": "最小牵引力",
          "range": "射程",
          "cone": "锥角",
          "tetherBreak": "牵引断开",
          "cargoForce": "货物牵引力",
          "cargoRange": "货物距离",
          "towForce": "拖曳力",
          "towDistance": "拖曳距离",
          "quantumTowMass": "QT 质量上限",
          "rotationSpeed": "旋转",
          "moveSpeed": "移动速度"
        },
        "shields": {
          "hp": "HP",
          "regen": "回复",
          "regenTime": "回复时间",
          "downedRegenDelay": "击穿延迟",
          "damagedRegenDelay": "受损延迟",
          "resistancePhysical": "物理抗性",
          "resistanceEnergy": "能量抗性",
          "resistanceDistortion": "扭曲抗性",
          "decay": "衰减",
          "absorption": {
            "physical": "物理吸收",
            "energy": "能量吸收",
            "distortion": "扭曲吸收"
          }
        },
        "coolers": {
          "coolingRate": "冷却速率"
        },
        "powerPlants": {
          "output": "输出",
          "pips": "能量档"
        },
        "flightControllers": {
          "scmSpeed": "SCM 速度",
          "boostSpeed": "加力速度",
          "navSpeed": "导航速度",
          "rotation": "俯仰 / 偏航 / 滚转",
          "boostedRotation": "加力俯仰 / 偏航 / 滚转",
          "boostCapacity": "加力容量",
          "boostRegen": "加力恢复",
          "boostRegenDelay": "加力恢复延迟",
          "boostRamp": "加力升 / 降时间"
        },
        "quantumDrives": {
          "speed": "速度",
          "range": "航程",
          "fuelConsumption": "消耗",
          "spoolUpTime": "蓄能",
          "cooldownTime": "冷却",
          "splineSpeed": "轨道",
          "accel": "加速度",
          "engageSpeed": "接入速度",
          "calibrationRate": "校准速率",
          "disconnectRange": "断开距离",
          "interdictionTime": "拦截时长",
          "splineAccel": "轨道加速",
          "splineSpoolUpTime": "轨道预热",
          "splineCooldownTime": "轨道冷却",
          "splineInterdictionTime": "轨道拦截",
          "jumpHeat": "跃迁热量"
        },
        "jumpDrives": {
          "fuelEfficiency": "燃料效率",
          "alignRate": "校准速率",
          "tuneRate": "调谐速率",
          "alignDecay": "校准衰减",
          "tuneDecay": "调谐衰减",
          "exitSpeed": "出口速度",
          "maxTunnelSpeed": "隧道最高速度",
          "respoolTime": "重新预热"
        },
        "radar": {
          "aimAssistRange": "辅助距离",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "被动探测",
          "active": "主动探测",
          "aimAssistBuffer": "辅助瞄准缓冲",
          "sensitivityModifier": "灵敏度修正",
          "contactGroups": {
            "GroundVehicle": "地面载具"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "热能",
          "deflectPhysical": "物理偏转",
          "deflectEnergy": "能量偏转",
          "selfPhysical": "自身物理抗性",
          "selfEnergy": "自身能量抗性"
        },
        "fuelIntakes": {
          "pushRate": "输送速率",
          "minRate": "最小速率"
        },
        "sources": {
          "game_files": "游戏文件",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "视图",
          "compact": "紧凑",
          "expanded": "展开"
        },
        "fuelTanks": {
          "hydrogen": "氢燃料箱",
          "quantum": "量子燃料箱"
        },
        "jumpDrive": "跳跃引擎",
        "maxContainerSize": "最大集装箱尺寸",
        "groups": {
          "avionic": "航电",
          "system": "系统",
          "propulsion": "推进",
          "thruster": "推进器",
          "weapon": "武器",
          "defense": "防御",
          "other": "货物",
          "auxiliary": "辅助",
          "seat": "座位",
          "external_fuel_tank": "外挂燃料箱",
          "ore_pod": "矿石舱",
          "module": "模块",
          "salvage": "回收",
          "refuel_boom": "加油臂"
        },
        "types": {
          "radar": "雷达",
          "computers": "电脑",
          "power_plants": "发电机",
          "coolers": "冷却器",
          "shield_generators": "护盾发生器",
          "fuel_intakes": "燃料进气口",
          "fuel_tanks": "燃料箱",
          "quantum_drives": "量子引擎",
          "jump_modules": "跳跃模块",
          "jumpdrive": "跳跃模块",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推进器",
          "maneuvering_thrusters": "机动推进器",
          "weapons": "武器",
          "turrets": "炮塔",
          "missiles": "导弹",
          "utility_items": "实用设备",
          "utility": "实用设备",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— 选择模块 —",
        "selectModule": "选择模块",
        "moduleStock": "出厂状态",
        "moduleStockHint": "插槽保持飞船出厂时的状态",
        "categories": {
          "radar": "雷达",
          "armor": "装甲",
          "relay": "中继",
          "countermeasures": "对抗措施",
          "lifesupport": "生命维持",
          "selfdestruct": "自毁",
          "batteries": "电池",
          "computers": "电脑",
          "powerplant": "发电机",
          "cooler": "冷却器",
          "module": "模块",
          "shieldgenerator": "护盾发生器",
          "fuel_intakes": "燃料进气口",
          "fueltanks": "燃料箱",
          "external_fuel_tanks": "外挂燃料箱",
          "ore_pods": "矿石舱",
          "salvage_storage": "回收储存",
          "refuel_boom": "加油臂",
          "quantumdrive": "量子引擎与跳跃模块",
          "jump_modules": "跳跃模块",
          "jumpdrive": "跳跃模块",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推进器",
          "maneuvering_thrusters": "机动推进器",
          "retro_thrusters": "反推推进器",
          "vtol_thrusters": "VTOL 推进器",
          "weapons": "武器",
          "weapon_mounts": "武器挂载",
          "turret": "炮塔",
          "missiles": "导弹",
          "missile_racks": "导弹架",
          "utility_items": "实用设备",
          "utility": "实用设备",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "打捞填充站",
          "cargogrid": "货物网格",
          "controller": "飞行刀片",
          "seat": "座位",
          "thrusters": "推进器",
          "bombcompartments": "炸弹舱"
        },
        "name": "名称",
        "category": "分类",
        "source": "来源",
        "powerConsumption": "功率消耗",
        "powerMinimumFraction": "待机功耗",
        "signatureEm": "电磁信号",
        "signatureIr": "红外信号",
        "mining": {
          "fracturePower": "破碎功率",
          "extractionPower": "提取功率",
          "range": "射程",
          "chargeTime": "充能 / 放能",
          "moduleSlots": "模块槽",
          "activation": "类型",
          "active": "主动",
          "passive": "被动",
          "charges": "使用次数",
          "duration": "持续时间",
          "modifiers": {
            "instability": "不稳定性",
            "resistance": "抗性",
            "optimalChargeWindow": "最佳充能窗口",
            "optimalChargeRate": "最佳充能速率",
            "catastrophicChargeRate": "灾难性充能速率",
            "shatterDamage": "碎裂伤害",
            "inertMaterials": "惰性物质"
          }
        },
        "salvage": {
          "salvageSpeed": "打捞速度",
          "radius": "光束半径",
          "extractionEfficiency": "提取效率"
        },
        "utility": {
          "capacity": "容量"
        },
        "selfDestruct": {
          "damage": "伤害",
          "radius": "爆炸半径",
          "time": "引爆延时"
        },
        "quantumEnforcement": {
          "jammerRange": "干扰范围",
          "pulseRadius": "脉冲半径",
          "chargeTime": "充能时间",
          "cooldownTime": "冷却时间"
        },
        "emp": {
          "distortionDamage": "扭曲伤害",
          "radius": "半径",
          "chargeTime": "充能时间",
          "unleashTime": "释放时间",
          "cooldownTime": "冷却"
        },
        "lifeSupport": {
          "output": "输出"
        },
        "powerRanges": "功率曲线（低 / 中 / 高）",
        "powerSegments": "段"
      },
      "blank": {
        "propulsion": "没有推进系统",
        "modular": "没有模块",
        "fleetInvites": "没有邀请"
      },
      "user": {
        "displayName": "显示名称",
        "displayNameInfo": "在你的公开机库、命名铭牌和舰队成员列表中代替用户名显示。",
        "hangarDefaultSort": "默认顺序",
        "hangarDefaultSortInfo": "按住舰船的拖动柄即可重新排序。仅在自定义顺序生效且未设置筛选时可用。",
        "hangarDefaultSortOptions": {
          "standard": "标准（旗舰优先，然后按名称）",
          "asc": "%{field}，升序",
          "desc": "%{field}，降序"
        },
        "rsiHandle": "用户名",
        "rsiHandleVerified": "已通过 Citizen iD 验证",
        "rsiHandleVerifiedViaProfile": "已通过 RSI 个人资料验证",
        "rsiVerification": {
          "title": "验证你的 RSI 用户名",
          "token": "验证码",
          "verifiedSince": "自 %{date} 起已验证",
          "openProfileSettings": "编辑你的 RSI 个人资料",
          "steps": {
            "copy": "复制你的验证码",
            "paste": "将它粘贴到你的 RSI 个人资料的简介中。用户名验证后即可将其删除。",
            "check": "检查 %{handle} 的公民页面"
          },
          "extension": {
            "title": "使用 FleetYards Sync 扩展验证",
            "verify": "使用扩展验证",
            "description": "扩展会将验证码添加到此浏览器所登录 RSI 账户的简介中，检查你的公民页面，然后再将验证码移除。",
            "detecting": "正在查找 FleetYards Sync 扩展",
            "install": "安装 FleetYards Sync 扩展，即可一键验证你的 Handle。",
            "update": "更新 FleetYards Sync 扩展即可一键验证你的 Handle：当前安装的版本尚不支持。",
            "handleMismatch": "此浏览器登录的 RSI 账户是 %{rsiHandle}，而不是 %{handle}。请以 %{handle} 登录 RSI，或在下方手动验证。",
            "notSignedIn": "请在此浏览器中登录 RSI 以使用扩展验证，或在下方手动验证。",
            "bioTooLong": "你的 RSI 简介太长，无法添加验证码。请缩短简介，或在下方手动验证。",
            "bioUnreadable": "你的 RSI 简介包含扩展无法原样保留的格式。请在下方手动验证。",
            "failed": "扩展无法更新你的 RSI 简介。请重试，或在下方手动验证。",
            "removeFailed": "扩展无法从你的 RSI 简介中移除验证码。请在 RSI 上手动移除。",
            "manual": "或手动验证："
          },
          "statuses": {
            "pending": "正在检查你的公民页面…",
            "token_missing": "你的简介中还没有该验证码。RSI 可能需要几分钟才会显示修改。",
            "handle_mismatch": "RSI 返回的页面属于另一个用户名。",
            "not_found": "RSI 上没有使用此用户名的公民。",
            "failed": "无法检查你的公民页面。请一分钟后重试。"
          }
        },
        "location": "位置",
        "currentSystem": "当前游戏内位置",
        "tester": "测试者?",
        "maintainer": "维护者？",
        "avatar": "头像",
        "unconfirmedEmail": "未确认的邮件",
        "saleNotify": "我希望收到销售通知",
        "publicHangar": "公开机库已启用",
        "publicHangarLoaners": "在公开机库显示借用船提示",
        "publicHangarStats": "公开机库统计已启用",
        "publicWishlist": "公开愿望清单已启用",
        "hideOwner": "为舰队隐藏所有权",
        "tracking": "允许匿名使用情况分析",
        "showOnlineStatus": "显示我的在线状态",
        "supporterListed": "支持者页面",
        "supporterListedPlatform": "按捐赠时的选择",
        "supporterListedShown": "显示我的用户名",
        "supporterListedHidden": "不显示我",
        "onlineStatus": "在线状态",
        "online": "在线",
        "offline": "离线",
        "lastActiveAt": "最后活跃",
        "confirmedAt": "确认于",
        "dateFormat": "日期格式",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "好友可见机库",
        "friendsHangarStats": "好友可见机库统计",
        "friendsWishlist": "好友可见愿望单"
      },
      "adminUser": {
        "superAdmin": "超级管理员",
        "passwordConfirmation": "确认密码"
      },
      "vehicle": {
        "customOrder": "自定义",
        "name": "名称",
        "states": "状态",
        "serial": "序列号",
        "owner": "指挥官",
        "flagship": "旗舰",
        "wanted": "想要",
        "loaner": "借用",
        "bundled": "捆绑",
        "bundledWith": "与 %{parent} 捆绑",
        "hiddenByUser": "已从机库中隐藏",
        "public": "公开可见",
        "fullPublic": "公开可见（包括名称）",
        "publicShort": "公开",
        "saleNotifyOn": "销售通知已开启",
        "saleNotifyOff": "销售通知已关闭",
        "nameVisible": "公开可见",
        "hidden": "隐藏?",
        "saleNotify": "我希望收到销售通知",
        "hangarGroups": "群组",
        "ownedPaintsSelect": {
          "label": "拥有的涂装",
          "pledged": "来自承诺包",
          "empty": "未找到涂装"
        },
        "modelPaintSelect": {
          "nullablePrompt": "选择涂装",
          "label": "涂装"
        },
        "bulkGroupEdit": {
          "hint": "现有群组将被覆盖！"
        },
        "hasLoaners": "借用船",
        "boughtViaSelect": {
          "label": "购买方式"
        }
      },
      "image": {
        "active": "活跃?",
        "background": "用作背景?",
        "caption": "标题",
        "enabled": "已启用?",
        "file": "图片文件",
        "global": "全局?",
        "delete": "删除",
        "start": "开始",
        "cancel": "取消",
        "processing": "处理中...",
        "error": "错误",
        "name": "名称",
        "size": "文件大小",
        "dropzone": "将图片拖放到此处",
        "cancelUpload": "取消上传",
        "startUpload": "开始上传",
        "selectImages": "添加图片...",
        "selectFolder": "添加文件夹..."
      },
      "signup": {
        "link": "还没有账户?",
        "privacyPolicy": "创建 FleetYards 账户即表示您同意我们的"
      },
      "privacyPolicy": "隐私政策",
      "login": "用户名或电子邮件",
      "username": "用户名",
      "twoFactorCode": "两步验证码",
      "confirmationCode": "确认码",
      "email": "电子邮件",
      "avatar": "头像",
      "alreadyRegistered": "已有账户?",
      "password": "密码",
      "passwordConfirmation": "确认密码",
      "rememberMe": "记住我",
      "emptyList": "没有 %{name}",
      "all": "全部",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "生成一个私有链接，将您已报名的活动添加到个人日历应用（Apple 日历、Google 日历、Outlook）。",
          "howTo": "将该链接粘贴到日历应用的“订阅日历”或“通过 URL 添加”中。任何拿到此链接的人都能看到您已报名的活动 — 请妥善保管。"
        },
        "supporterNomination": {
          "label": "舰队支持",
          "hint": "只要捐赠有效，其成员即可使用舰队功能。你可以在捐赠前选择。",
          "perDonation": "按捐赠设置",
          "perDonationHint": "单笔捐赠可以支持与常用舰队不同的舰队。",
          "fleet": "受支持的舰队"
        },
        "supporterClaimKey": {
          "signedOut": "请登录以获取您的专属支持者密钥。",
          "patreonNote": "通过您的邮箱关联，无需密钥",
          "label": "您的密钥",
          "hint": "将其粘贴到 PayPal、Ko-fi 或 Buy me a coffee 付款的留言中，付款即可与您的账号关联。Patreon 则通过邮箱关联。"
        }
      },
      "filters": {
        "locations": {
          "name": "搜索地点",
          "system": "星系",
          "parent": "位于",
          "kind": "类型",
          "starmap": "游戏内地图",
          "shownOnStarmap": "显示在地图上",
          "hiddenOnStarmap": "在地图上隐藏"
        },
        "components": {
          "name": "名称",
          "buyPriceGt": "买入价格 >=",
          "buyPriceLt": "买入价格 <=",
          "sellPriceGt": "卖出价格 >=",
          "sellPriceLt": "卖出价格 <=",
          "storeImageBlank": "没有商店图片?",
          "description": "描述",
          "manufacturer": "制造商",
          "category": "分类",
          "subType": "子类型"
        },
        "shops": {
          "name": "名称",
          "type": "类型",
          "model": "飞船",
          "equipment": "装备",
          "component": "组件",
          "commodity": "商品",
          "commodityType": "商品类型"
        },
        "shopCommodities": {
          "commodityType": "商品类型",
          "equipment": "装备",
          "component": "组件",
          "commodity": "商品",
          "model": "飞船",
          "name": "名称"
        },
        "shopItems": {
          "category": "分类",
          "subCategory": "子分类",
          "name": "名称",
          "manufacturer": "制造商"
        },
        "stations": {
          "name": "名称",
          "type": "空间站类型",
          "shops": "商店",
          "docks": "停靠口"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "价格 <=",
          "priceGt": "价格 >=",
          "wanted": "想要",
          "hidden": "隐藏",
          "public": "公开",
          "group": "群组",
          "loaner": "借用船",
          "bundled": "捆绑的舰载小艇",
          "hiddenByUser": "隐藏的舰船",
          "boughtVia": "购买方式?",
          "image": "图片",
          "imageSources": {
            "custom": "非默认",
            "upload": "已上传",
            "gallery": "来自图库",
            "default": "默认"
          },
          "dedication": "命名铭牌"
        },
        "models": {
          "name": "名称",
          "classification": "分类",
          "focus": "定位",
          "manufacturer": "制造商",
          "onSale": "在售",
          "ingameOnly": "仅游戏内获取",
          "canLandOnPlanets": "可在行星降落",
          "size": "尺寸",
          "dockSize": "停靠尺寸",
          "price": "价格",
          "pledgePrice": "质押价格",
          "productionStatus": "生产状态",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "价格 <=",
          "priceGt": "价格 >=",
          "willItFit": "Will it Fit?",
          "withCargo": "有货物?",
          "scKeyBlank": "没有 SC Key?",
          "positionsNeedCuration": "岗位需人工校订?",
          "fleetchartImageBlank": "没有舰队图表图片?",
          "holoBlank": "没有 Holo?",
          "frontViewBlank": "没有前视图图片?",
          "topViewColoredBlank": "没有彩色俯视图图片?",
          "vehicleSize": "载具尺寸",
          "dimensionsDrifted": "尺寸与游戏文件不一致",
          "dimensionsMeasuredAtNull": "没有实测尺寸?"
        },
        "modelModules": {
          "name": "名称"
        },
        "manufacturers": {
          "name": "名称",
          "withModels": "有型号的",
          "logoBlank": "无标志"
        },
        "supporterContributions": {
          "name": "按名称搜索",
          "recurring": "周期性",
          "anonymous": "匿名",
          "startedAtGteq": "开始日期不早于",
          "startedAtLteq": "开始日期不晚于",
          "user": "关联账户",
          "linked": "账户关联",
          "linkedOnly": "已关联",
          "linkedVia": "关联方式",
          "unlinkedOnly": "未关联",
          "sourceStated": "已注明平台",
          "sourceStatedOnly": "已注明平台",
          "sourceUnspecifiedOnly": "未注明平台",
          "source": "来源"
        },
        "adminNotifications": {
          "search": "搜索"
        },
        "images": {
          "model": "飞船"
        },
        "users": {
          "search": "搜索",
          "username": "用户名",
          "email": "电子邮件",
          "rsiHandle": "RSI 用户名"
        },
        "fleets": {
          "name": "名称",
          "fid": "FID",
          "memberCountGteq": "最少成员数",
          "memberCountLteq": "最多成员数",
          "rsiVerified": "已通过 RSI 验证",
          "publicFleet": "公开",
          "recruiting": "招募中",
          "createdOnGteq": "创建日期不早于",
          "createdOnLteq": "创建日期不晚于",
          "member": "成员",
          "members": {
            "search": "用户名或昵称",
            "role": "角色",
            "state": "状态",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until",
            "inactiveSince": "不活跃起始日期",
            "verified": "RSI 组织",
            "verifiedYes": "已验证",
            "verifiedNo": "未验证",
            "withoutRsiHandle": "没有 RSI 账号名",
            "withoutDiscord": "未关联 Discord",
            "withoutSquadron": "未加入中队"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "搜索物品..."
          }
        },
        "manufacturer": "制造商",
        "commodities": {
          "description": "描述",
          "traded": "有地方交易",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "买入价格 >=",
          "buyPriceLt": "买入价格 <=",
          "sellPriceGt": "卖出价格 >=",
          "sellPriceLt": "卖出价格 <=",
          "storeImageBlank": "没有商店图片?"
        },
        "equipment": {
          "name": "名称",
          "equipmentType": "装备类型",
          "itemType": "物品类型",
          "weaponClass": "武器类别",
          "slot": "部位",
          "size": "尺寸",
          "grade": "等级",
          "buyPriceGt": "买入价格 >=",
          "buyPriceLt": "买入价格 <=",
          "sellPriceGt": "卖出价格 >=",
          "sellPriceLt": "卖出价格 <=",
          "storeImageBlank": "没有商店图片?",
          "subType": "子类型"
        },
        "notifications": {
          "search": "搜索"
        },
        "blueprints": {
          "org": "发放方",
          "scKey": "游戏键名",
          "withKnownSource": "有已知来源",
          "withCraftable": "产出在目录中",
          "currentVersion": "在当前版本中",
          "name": "搜索蓝图",
          "craftableType": "产出",
          "source": "来源",
          "withSource": "有已知来源",
          "withoutSource": "无已知来源",
          "alignment": "来源阵营",
          "material": "使用材料",
          "ownedFilter": "已拥有",
          "owned": "已拥有",
          "notOwned": "未拥有"
        },
        "missions": {
          "location": "地点",
          "ship": "你的飞船",
          "name": "搜索任务",
          "org": "发布方",
          "standing": "声望",
          "rewarding": "奖励",
          "alignment": "阵营立场",
          "kind": "类型",
          "releasedFilter": "正式版",
          "released": "在正式版中",
          "unreleased": "未在正式版"
        },
        "fleetDirectory": {
          "search": "名称、FID 或 SID",
          "memberCountGteq": "最少成员数",
          "activity": "活动",
          "language": "语言",
          "alignment": "阵营",
          "commitment": "投入程度",
          "timezone": "时区",
          "recruiting": "仅招募中",
          "roleplay": "仅角色扮演"
        }
      },
      "station": {
        "docks": "停靠口",
        "location": "位置",
        "type": "类型",
        "shops": "商店",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "intro": "根据你的飞船、预算和可接受的价格时效，找出两个终端之间最好的一趟运输。价格来自 UEX，每小时更新。",
        "yourRun": "你的航程",
        "ship": "飞船",
        "noShip": "选择飞船以按每趟利润排序",
        "noShipShort": "未选飞船",
        "scu": "%{count} SCU",
        "budget": "预算",
        "budgetPlaceholder": "可选",
        "buyIn": "购买星系",
        "anySystem": "全部",
        "commodity": "商品",
        "allCommodities": "全部商品",
        "priceAge": "价格不早于",
        "priceAges": {
          "day": "24 小时",
          "threeDays": "3 天",
          "any": "不限"
        },
        "bestRun": "最佳航程",
        "buyAt": "购买地点",
        "sellAt": "出售地点",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "跃迁至 %{system}",
        "pricesFrom": "价格来自 %{time}",
        "otherBuyers": {
          "one": "另有 %{count} 处收购",
          "other": "另有 %{count} 处收购"
        },
        "profitThisRun": "本趟利润",
        "profitPerScu": "每 SCU 利润",
        "aUecPerScu": "aUEC · 每 SCU %{value}",
        "load": "载货量",
        "loadOf": "%{load} / %{cargo} SCU",
        "thisShip": "此飞船",
        "unflyable": {
          "origin": "%{ship} 无法在 %{terminal} 降落",
          "destination": "%{ship} 无法在 %{terminal} 降落",
          "both": "%{ship} 在两端都无法降落"
        },
        "loadLimits": {
          "hold": "货舱已满",
          "stock": "受库存限制",
          "demand": "受需求限制",
          "budget": "受预算限制"
        },
        "youSpend": "花费",
        "pickShipForRun": "选择飞船以查看一趟的利润。",
        "moreRuns": "更多航程",
        "runs": "航程",
        "rankBy": "排序依据",
        "profitPerRun": "每趟利润",
        "profitPerDistance": "每 Gm 利润",
        "shortest": "最短",
        "buySell": "买入 → 卖出",
        "spend": "花费",
        "distance": "距离",
        "prices": "价格",
        "profit": "利润",
        "to": "至",
        "everyBuyer": "从 %{terminal} 收购 %{commodity} 的所有地点",
        "empty": "没有匹配的航程。试试更早的价格或其他星系。",
        "loadExplained": "载货量按两个终端和商品都接受的货箱尺寸计算，并受购买地库存、出售地需求和你的预算限制。",
        "poweredByUex": "价格由 UEX 提供"
      },
      "hardpoints": {
        "prefix": "使用以下工具试用配置",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "数据基于以下网站的计算公式"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "选择飞船"
      },
      "table": {
        "selected": "%{count} 已选择",
        "selectRow": "选择行",
        "selectAll": "选择所有行"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "价格",
        "type": "类型",
        "shop": "商店"
      },
      "hangarPledgeItems": {
        "openOnRsi": "在 RSI 机库中打开",
        "flair": "机库装饰",
        "upgrades": "升级 / CCU",
        "equipment": "FPS 装备",
        "createdOn": "创建于",
        "meltable": "可熔炼",
        "withValue": "有熔炼价值",
        "paints": "涂装",
        "pledge": "承诺 %{id}",
        "meltValue": "熔炼价值",
        "partOf": "属于 %{name}",
        "pledgeValue": "承诺价值",
        "quantity": "数量",
        "search": "按名称搜索"
      },
      "buybacks": {
        "name": "可回购承诺",
        "search": "搜索可回购承诺",
        "kind": "类型",
        "kinds": {
          "package": "礼包",
          "ship": "单船",
          "upgrade": "升级",
          "paint": "涂装",
          "addon": "附加内容",
          "other": "其他"
        },
        "upgraded": "已升级",
        "reclaimedOn": "熔炼于",
        "notAvailable": "不可用",
        "price": "价格",
        "insurance": "保险",
        "lifetimeInsurance": "终身保险",
        "noInsurance": "无保险",
        "insuranceMonths": {
          "one": "%{count} 个月",
          "other": "%{count} 个月"
        },
        "openOnRsi": "在 RSI 回购",
        "remove": "移除",
        "priceRange": "价格范围",
        "priceMin": "最低价格（USD）",
        "priceMax": "最高价格（USD）",
        "upgradeFrom": "升级自",
        "upgradeTo": "升级至",
        "gets": "可获得该舰船"
      },
      "buybackSync": {
        "extensionVersion": "已安装的扩展版本",
        "detailsProgress": "正在读取回购价格",
        "pages": "页数",
        "found": "找到的可回购承诺",
        "added": "新增",
        "removed": "已移除",
        "prices": "已读取价格",
        "background": {
          "finished": "回购同步已完成",
          "incomplete": "回购同步已完成，部分价格缺失",
          "unsupported": "回购同步需要更新版本的扩展",
          "failed": "回购同步失败"
        },
        "status": {
          "fetching": "正在读取回购页面",
          "submitting": "正在保存",
          "finished": "已完成",
          "unsupported": "不支持",
          "failed": "失败"
        }
      },
      "syncExtension": {
        "warnings": "警告",
        "backgroundProgress": "正在同步机库",
        "backgroundFinished": "机库同步已完成",
        "backgroundFailed": "机库同步失败",
        "backgroundCancelled": "机库同步已取消",
        "status": {
          "started": "导入已开始...",
          "finished": "导入完成",
          "failed": "导入失败!",
          "cancelled": "导入已取消"
        },
        "processSteps": {
          "fetchHangar": "正在从 RSI 机库获取数据",
          "submitData": "正在提交数据到 Fleetyards.net 后台"
        },
        "sessionStatus": "RSI 会话状态",
        "signedInAs": "已以 %{handle} 登录 RSI",
        "signInToRsi": "登录 RSI",
        "checkIdentity": "检查 RSI 会话",
        "targetGroup": "找到的飞船归入的分组",
        "addBundledVehicles": "添加附带的小型飞船",
        "addBundledVehiclesHint": "添加飞船附带的小型飞船。已在机库中的会保留。",
        "syncPaints": "同步涂装",
        "syncPaintsHint": "用你 RSI 机库中的涂装替换已保存的涂装。关闭时保留已保存的涂装不变。",
        "syncHangarFlair": "同步机库装饰",
        "syncHangarFlairHint": "用你 RSI 机库中的机库装饰替换已保存的装饰。关闭时保留已保存的装饰不变。",
        "syncCcus": "同步 CCU",
        "syncCcusHint": "用你 RSI 机库中的 CCU 替换已保存的 CCU。关闭时保留已保存的 CCU 不变。",
        "syncEquipment": "同步 FPS 装备",
        "syncEquipmentHint": "用你 RSI 机库中的 FPS 装备替换已保存的装备。关闭时保留已保存的装备不变。",
        "settings": "设置",
        "unmatchedVehiclesAction": "不在 RSI 机库中的飞船",
        "unmatchedVehiclesActionHint": "如何处理这里有、但同步在你的 RSI 认购清单中找不到的飞船。",
        "unmatchedHangarGroup": "归入的分组",
        "unmatchedHangarGroupHint": "飞船保持原样，只是收集到这个分组里，方便你逐一处理。",
        "unmatchedVehiclesActions": {
          "wishlist": "移至愿望清单",
          "delete": "删除",
          "keep": "保持不变",
          "group": "归入一个分组"
        },
        "identityStatus": {
          "pending": "检查中...",
          "notFound": "未找到",
          "connected": "已连接"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "页面",
          "all": "所有质押物品",
          "ships": "飞船",
          "components": "模块",
          "upgrades": "升级",
          "paints": "涂装",
          "hangarFlair": "机库装饰",
          "paintsNotSynced": "涂装（不会同步）",
          "hangarFlairNotSynced": "机库装饰（不会同步）",
          "equipment": "FPS 装备",
          "ccus": "升级 / CCU",
          "ccusNotSynced": "CCU（未同步）",
          "equipmentNotSynced": "FPS 装备（不会同步）",
          "extras": "其他物品（归入机库装饰和 FPS 装备）"
        },
        "importedItems": {
          "importedVehicles": "已添加飞船",
          "foundVehicles": "找到的飞船",
          "movedVehiclesToWanted": "飞船已移至愿望清单",
          "deletedVehicles": "已删除的飞船",
          "groupedVehicles": "已归入分组的飞船",
          "unchangedVehicles": "保持不变的飞船",
          "missingModels": "未找到飞船",
          "importedComponents": "已添加组件",
          "foundComponents": "找到的组件",
          "missingComponents": "未找到组件",
          "missingComponentVehicles": "未找到匹配的飞船用于组件",
          "importedUpgrades": "已添加升级",
          "foundUpgrades": "找到的升级",
          "syncedPaints": "已同步涂装",
          "syncedHangarFlair": "已同步机库装饰",
          "syncedCcus": "已同步 CCU",
          "syncedEquipment": "已同步 FPS 装备",
          "missingUpgrades": "未找到升级",
          "missingUpgradeVehicles": "未找到匹配的飞船用于升级"
        },
        "incomplete": "您的 RSI 机库中有部分物品无法读取，因此本次未找到的飞船保持不变。"
      },
      "cargoGridViewer": {
        "capacity": "容量",
        "maxContainerSize": "最大集装箱",
        "packed": "已装载",
        "totalCargo": "总货物",
        "didNotFit": "放不下",
        "enoughShips": "四艘飞船已填满网格。",
        "addShip": "添加飞船",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "量子引擎",
        "fuelUsage": "燃料消耗",
        "travelTime": "旅行时间",
        "poweredBy": "基于",
        "rank": "#",
        "size": "尺寸",
        "grade": "等级",
        "sizeValue": "S%{size}",
        "intro": "每台量子引擎完成这次跃迁需要多久——以及消耗多少量子燃料。",
        "jumpDistance": "跃迁距离",
        "distanceHint": "1 Mkm 即一百万公里。横穿斯坦顿约需 40。",
        "filters": "筛选",
        "resetFilters": "重置",
        "barLegend": "长条表示相对最慢引擎的时间",
        "count": "%{count} 台引擎",
        "countFiltered": "%{total} 台中的 %{count} 台",
        "noMatch": "没有引擎符合这些筛选条件。",
        "presets": {
          "moon": "月球距离",
          "short": "短距跃迁",
          "system": "横穿斯坦顿",
          "far": "长途"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "全部",
            "description": "舰船、模块、涂装、借用舰船和舰船价格，一次全部加载。"
          },
          "ship_matrix": {
            "name": "舰船",
            "description": "来自 RSI 舰船矩阵的全部舰船及其数据与商店信息。"
          },
          "modules": {
            "name": "模块",
            "description": "来自 RSI 商店的舰船模块。"
          },
          "paints": {
            "name": "涂装",
            "description": "来自 RSI 商店的涂装。"
          },
          "loaners": {
            "name": "借用舰船",
            "description": "每艘舰船附带哪些借用舰船，来自 RSI。"
          },
          "uex_vehicle_prices": {
            "name": "舰船价格",
            "description": "游戏内购买和租用舰船的地点，来自 UEX。"
          },
          "sc_data": {
            "name": "游戏数据 · %{environment}",
            "description": "解析后游戏文件中的全部目录：组件、装备、商品、蓝图、任务和地点。"
          },
          "sc_data_models": {
            "name": "游戏文件中的舰船",
            "description": "仅舰船，来自默认版本。"
          },
          "uex_commodity_prices": {
            "name": "商品价格",
            "description": "终端价格和库存，来自 UEX。"
          },
          "uex_component_prices": {
            "name": "组件价格",
            "description": "组件的出售地点，来自 UEX。"
          },
          "uex_equipment_prices": {
            "name": "装备价格",
            "description": "装备的出售地点，来自 UEX。"
          },
          "uex_trade_routes": {
            "name": "终端和贸易路线",
            "description": "UEX 的终端及其之间的贸易路线。"
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "上级",
          "system": "星系",
          "scKey": "游戏键",
          "scRefs": "游戏引用",
          "slug": "Slug",
          "gameType": "游戏类型",
          "build": "版本",
          "children": "内部地点",
          "missions": "关联任务",
          "missionTemplates": "任务模板",
          "shownWithParentOnly": "仅随上级显示",
          "yes": "是",
          "no": "否",
          "unavailable": "不可用",
          "appearance": "外观",
          "image": "图片",
          "color": "颜色",
          "appearanceHint": "颜色会填满行星或卫星的圆圈，并渲染成受光照的球体。留空时，会在上传图片时从图片中提取。",
          "headerImageHint": "图片会作为该地点页面的头图显示。",
          "shops": "商店",
          "shopImageHint": "图片会作为商店页面的头图显示。",
          "sunHint": "颜色会为恒星的光晕着色。"
        },
        "blueprints": {
          "status": {
            "sourceKnown": "来源已知",
            "outputResolved": "产出在目录中"
          },
          "columns": {
            "source": "来源",
            "output": "产出",
            "build": "版本",
            "created": "创建于",
            "slot": "槽位",
            "material": "材料",
            "type": "类型",
            "quantity": "数量",
            "minQuality": "最低品质",
            "stat": "属性",
            "change": "变化",
            "base": "基准",
            "ramp": "曲线",
            "kind": "类别",
            "org": "组织",
            "mission": "任务",
            "standing": "声望",
            "pool": "奖励池"
          },
          "makes": "产出",
          "noOutput": "不在任何目录中",
          "slug": "Slug",
          "scKey": "游戏键名",
          "scRef": "游戏引用",
          "build": "版本",
          "state": "状态",
          "states": {
            "current": "当前",
            "retired": "已移除"
          },
          "createdAt": "创建于",
          "updatedAt": "更新于"
        },
        "missions": {
          "unnamed": "游戏从未命名",
          "slug": "Slug",
          "scKey": "游戏键",
          "scRef": "游戏引用",
          "generator": "生成器",
          "debugName": "调试名称",
          "build": "版本",
          "difficultyAxes": "难度（技巧 / 负担 / 风险 / 理解）",
          "state": "状态",
          "states": {
            "retired": "已移除",
            "released": "在正式版",
            "unreleased": "未在正式版"
          },
          "columns": {
            "released": "在正式版",
            "generator": "生成器",
            "build": "版本",
            "rewardKind": "类型",
            "amount": "数量",
            "rewardDetail": "详情"
          },
          "filters": {
            "debugName": "调试名称",
            "named": "已命名",
            "unnamed": "从未命名",
            "namedFilter": "命名",
            "currentBuild": "仅当前版本",
            "anyBuild": "任意版本",
            "build": "版本"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "在线用户"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "其他"
          },
          "linkedVia": {
            "patreon_account": "Patreon 账户",
            "claim_key": "支持者令牌",
            "payer_email": "付款人邮箱",
            "manual": "管理员设置"
          }
        },
        "announcements": {
          "columns": {
            "title": "标题",
            "status": "状态",
            "deliveries": "渠道",
            "recipients": "接收人数",
            "publishedAt": "发送时间"
          },
          "statuses": {
            "draft": "草稿",
            "scheduled": "已排期",
            "publishing": "发送中",
            "published": "已发送",
            "failed": "失败"
          },
          "channels": {
            "in_app": "应用内",
            "discord": "Discord",
            "bluesky": "Bluesky"
          },
          "deliveryStatuses": {
            "pending": "待处理",
            "succeeded": "已发送",
            "skipped": "已跳过",
            "failed": "失败"
          },
          "lastTested": "上次测试 %{time}",
          "noChannel": "至少选择一个渠道。",
          "notifyUsersInfo": "仅已开启的人收到邮件。",
          "discordPartsInfo": "留空：自动拆分。",
          "socialPartsInfo": "留空：一条帖子，超长截断。两条以上：话题串。",
          "recipientsCount": "%{count} 位收件人",
          "partPosition": "第 %{position} / %{total} 条",
          "deliverySummary": "已发送 %{sent}/%{total}",
          "deliveryFailedCount": "%{count} 个失败",
          "deliveryPendingCount": "%{count} 个待处理",
          "deliverySkippedCount": "%{count} 个已跳过",
          "attempts": "尝试 %{count} 次",
          "content": "内容",
          "manualPostsInfo": "发送到 Bluesky 的文本，可手动发布到 X 或其他平台。",
          "engagement": {
            "likes": "点赞",
            "reposts": "转发",
            "replies": "回复",
            "quotes": "引用",
            "noReactions": "暂无表情回应。",
            "fetchedAt": "更新于 %{time}",
            "notFetched": "数据将在一小时内到达。",
            "untracked": "发布时尚未记录表情回应。"
          }
        },
        "resourceAccess": {
          "title": "资源权限",
          "groups": {
            "ship_data": "飞船数据",
            "community": "社区",
            "system": "系统"
          },
          "privileges": {
            "locations": "地点",
            "blueprints": "蓝图",
            "models": "型号",
            "model_modules": "型号模块",
            "components": "组件",
            "manufacturers": "制造商",
            "vehicles": "载具",
            "images": "图片",
            "fleets": "舰队",
            "users": "用户",
            "supporters": "支持者",
            "admins": "管理员",
            "announcements": "公告",
            "oauth_applications": "OAuth 应用",
            "maintenance": "维护",
            "imports": "导入",
            "features": "功能",
            "workers": "工作进程",
            "pghero": "PgHero",
            "rsi-api-status": "RSI API 状态",
            "stats": "统计"
          }
        },
        "versions": {
          "blank": "空",
          "revertQuestion": "要还原吗?",
          "sources": {
            "custom": "管理员",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "游戏文件",
            "sc_loader": "游戏文件",
            "uex_price_sync": "UEX 价格同步",
            "unknown": "未知"
          }
        },
        "models": {
          "unlisted": "未收录"
        }
      },
      "hangarTable": {
        "extraColumns": "列",
        "columns": {
          "storeImage": "图片",
          "storeImageWide": "宽图片",
          "angledView": "3D 图片",
          "angledViewWide": "宽 3D 图片",
          "modelManufacturerName": "制造商",
          "modelLength": "长度",
          "modelBeam": "宽度",
          "modelHeight": "高度",
          "modelMass": "质量",
          "modelCargo": "货物",
          "modelCrew": "船员",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelFocus": "定位",
          "modelProductionStatus": "生产状态",
          "modelPrice": "价格",
          "modelPledgePrice": "质押价格"
        }
      },
      "fleetTable": {
        "extraColumns": "列",
        "columns": {
          "storeImage": "图片",
          "storeImageWide": "宽图片",
          "angledView": "3D 图片",
          "angledViewWide": "宽 3D 图片",
          "modelManufacturerName": "制造商",
          "modelLength": "长度",
          "modelBeam": "宽度",
          "modelHeight": "高度",
          "modelMass": "质量",
          "modelCargo": "货物",
          "modelCrew": "船员",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelProductionStatus": "生产状态",
          "modelPrice": "价格",
          "modelPledgePrice": "质押价格",
          "owner": "所有者",
          "vehiclesCount": "数量"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "仅中队"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "超出货舱容量",
        "cargoGrid": "货舱网格",
        "shipInventory": "飞船库存",
        "remaining": "剩余",
        "unmeasured": "%{count} 项尚未测量",
        "transferTarget": "接收方",
        "transferNote": "备注",
        "noStock": "没有可移动的物品",
        "overStock": "超过该条目的库存",
        "incoming": "接收",
        "outgoing": "发出",
        "transferStates": {
          "pending": "等待中",
          "completed": "已送达",
          "declined": "已拒绝",
          "cancelled": "已撤回",
          "expired": "已过期"
        },
        "acceptInto": "接收至",
        "reportReason": "原因",
        "reportReasons": {
          "spam": "垃圾信息",
          "harassment": "骚扰",
          "scam": "诈骗",
          "other": "其他"
        },
        "transferToFleet": "%{fleet}（舰队）",
        "sender": "来自",
        "recipient": "发往",
        "contents": "内容",
        "state": "状态",
        "sentAt": "发送时间",
        "transferKinds": {
          "inventory": "我的库存",
          "fleet": "舰队",
          "user": "某人",
          "mine": "我的库存",
          "fleetInventories": "该舰队",
          "contract": "我参与的合同"
        },
        "transferTargetKind": "发送至",
        "contractDeliveryTarget": "%{contract}（%{fleet}）：%{destination}",
        "transferFromFleet": "来自舰队",
        "noTransferTargets": "这里没有可发送的目标",
        "recordedAt": "记录时间",
        "origin": "来自 / 发往",
        "inTransitAmount": "%{amount} 运送中",
        "inTransitHint": "已随一笔尚未被答复的转移送出，已不计入上方总数。",
        "transferFromFriends": "我的好友",
        "towardsContract": "计入合约",
        "noContract": "不计入合约",
        "forContract": "用于",
        "openInCatalogue": "在目录中打开"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "收件箱",
        "archive": "归档",
        "unreadOnly": "仅未读",
        "status": "状态",
        "severity": "严重程度",
        "type": "类型",
        "selectPrompt": "选择一条通知以阅读",
        "noBody": "此通知没有更多详情。",
        "lastSeen": "最后出现",
        "expires": "过期时间",
        "severities": {
          "info": "信息",
          "warning": "警告",
          "error": "错误"
        },
        "types": {
          "paints_import": "涂装导入",
          "modules_import": "模块导入",
          "loaner_sync": "借用船同步",
          "uex_prices_import": "UEX 价格同步",
          "uex_commodity_prices_import": "UEX 商品同步",
          "uex_component_prices_import": "UEX 部件同步",
          "uex_equipment_prices_import": "UEX 装备同步",
          "uex_trade_routes_sync": "UEX 贸易路线同步",
          "new_supporter": "新支持者",
          "rsi_api_blocked": "RSI API 被封锁",
          "rsi_api_unblocked": "RSI API 已恢复",
          "rsi_markup_changed": "RSI 页面已变更",
          "weekly_stats": "每周报告",
          "ship_matrix_import": "Ship Matrix 导入",
          "sc_data_import": "sc_data 导入",
          "sc_data_unlisted_models": "未收录飞船",
          "import_run": "导入",
          "oauth_application_review": "OAuth 应用审核",
          "inventory_transfer_reports": "被举报的库存转移"
        }
      },
      "optional": "可选",
      "notificationActions": {
        "open": "打开",
        "openHangar": "打开机库",
        "openModel": "查看飞船",
        "openInvite": "查看邀请",
        "reviewRequest": "审核申请",
        "openMembers": "查看成员",
        "openFleet": "打开舰队",
        "openInventory": "打开库存",
        "openEvent": "打开活动",
        "openRoster": "查看报名",
        "addToCalendar": "添加到日历",
        "openStore": "质押商店",
        "accept": "接受",
        "decline": "拒绝",
        "signUp": "报名",
        "withdraw": "取消报名",
        "syncAgain": "再次同步",
        "markAsBought": "标记为已购买",
        "unavailable": "此内容已不再可用。",
        "openTransfers": "打开转移",
        "openFriends": "打开好友",
        "openAllies": "打开盟友",
        "openTour": "打开行程",
        "openSquadron": "打开中队",
        "openContract": "打开合约",
        "openPayouts": "打开分账"
      },
      "notificationTypes": {
        "channels": {
          "app": "应用",
          "mail": "邮件",
          "push": "推送",
          "discord": "Discord"
        },
        "groups": {
          "account": "账户与机库",
          "announcements": "公告",
          "fleetMembership": "舰队成员资格",
          "fleetEvents": "舰队活动",
          "logistics": "物流",
          "relationships": "好友与盟友",
          "tours": "行程",
          "fleetContracts": "舰队合约"
        },
        "announcement": "公告",
        "hangar_sync_finished": "机库同步完成",
        "hangar_sync_failed": "机库同步失败",
        "model_on_sale": "型号特价销售",
        "new_model": "新型号发布",
        "fleet_invite": "收到舰队邀请",
        "fleet_member_requested": "收到加入申请",
        "fleet_member_accepted": "成员申请已通过",
        "fleet_request_accepted": "加入申请已通过",
        "fleet_joined_by_discord_role": "通过 Discord 身份组加入",
        "fleet_inventory_item_added": "舰队库存新增物品",
        "fleet_event_published": "活动已发布",
        "fleet_event_locked": "活动报名已锁定",
        "fleet_event_starting_soon": "活动即将开始",
        "fleet_event_started": "活动已开始",
        "fleet_event_completed": "活动已完成",
        "fleet_event_cancelled": "活动已取消",
        "fleet_event_signup_added": "新增报名",
        "fleet_event_signup_withdrawn": "报名已取消",
        "fleet_event_signup_confirmed": "报名已确认",
        "fleet_event_signup_assigned": "已分配席位",
        "fleet_event_signup_kicked": "已被移出席位",
        "allInGroup": "此分组中的全部",
        "inventory_transfer_received": "收到转移",
        "inventory_transfer_resolved": "转移已答复",
        "friend_request_received": "收到好友请求",
        "friend_request_accepted": "好友请求已通过",
        "fleet_ally_request_received": "收到结盟请求",
        "fleet_ally_request_accepted": "结盟请求已通过",
        "tour_join_request_received": "收到参加申请",
        "tour_join_request_accepted": "参加申请已通过",
        "fleet_squadron_request_received": "中队加入申请",
        "fleet_squadron_request_accepted": "中队申请已通过",
        "fleet_contract_published": "合约已发布",
        "fleet_announcement_posted": "公告已发布",
        "fleet_contract_claimed": "合约已接取",
        "fleet_contract_crew_requested": "有人想加入合约",
        "fleet_contract_crew_answered": "合约成员申请已处理",
        "fleet_subscription_started": "已获得舰队功能",
        "fleet_subscription_ended": "已失去舰队功能",
        "fleet_fid_claim_opened": "舰队 ID 被申领",
        "fleet_fid_claim_completed": "舰队 ID 已转移",
        "fleet_fid_claim_cancelled": "舰队 ID 申领已结束",
        "fleet_rsi_verification_lost": "舰队验证已失效",
        "rsi_handle_verification_lost": "RSI 用户名验证已失效",
        "fleet_contract_fulfilled": "合约已完成",
        "fleet_contract_settled": "合同已结算",
        "payout_ledger_settled": "分账已结算",
        "payout_entry_pending_review": "支出待审核",
        "payout_entry_declined": "支出已拒绝",
        "fleet_verification_requested": "你的舰队请求验证"
      },
      "fleets": {
        "missions": {
          "untitled": "未命名任务",
          "title": "标题",
          "description": "描述",
          "team": "小队",
          "teams": "小队",
          "ship": "飞船",
          "ships": "飞船",
          "slot": "席位",
          "slots": "席位",
          "noMissions": "暂无任务。",
          "noTeams": "尚未添加小队。",
          "noShips": "尚未添加飞船。",
          "noSlots": "尚未添加席位。",
          "archivedTab": "已归档",
          "activeTab": "进行中",
          "archived": "已归档",
          "modelSpecific": "指定飞船",
          "modelList": "以下任意一种",
          "modelListHint": "该席位接受您所选飞船中的任意一种。",
          "allowedShips": "符合条件的飞船",
          "anyOf": "任意一种",
          "filterRange": "筛选范围",
          "classification": "分类",
          "focus": "定位",
          "minSize": "最小尺寸",
          "maxSize": "最大尺寸",
          "minCrew": "最少船员",
          "minCrewOverride": "覆盖",
          "minCrewOverrideLabel": "最少船员覆盖值",
          "minCrewOverrideHint": "留空则使用该飞船的船员数。",
          "minCargo": "最小货舱（SCU）",
          "createdBy": "创建者",
          "seats": "座位",
          "category": "分类",
          "coverImage": "封面图片",
          "scenario": "场景",
          "categories": {
            "other": "其他",
            "ship_combat": "飞船战斗",
            "ground_combat": "地面战斗",
            "combined_combat": "联合作战",
            "mining": "采矿",
            "salvage": "回收",
            "cargo_hauling": "货运",
            "exploration": "探索"
          }
        },
        "events": {
          "untitled": "未命名活动",
          "title": "标题",
          "description": "描述",
          "briefing": "简报",
          "startsAt": "开始时间",
          "endsAt": "结束时间",
          "timezone": "时区",
          "location": "活动地点",
          "meetupLocation": "集合地点",
          "visibility": "可见性",
          "maxAttendees": "最多参与人数",
          "autoLockEnabled": "自动锁定报名",
          "autoLockMinutesBefore": "开始前多少分钟锁定",
          "recurring": "重复",
          "recurringHint": "按周期自动生成此活动。成员需为每一场次单独报名。",
          "recurringSummary": "重复：%{interval}",
          "recurringUntil": "重复：%{interval}，截止 %{date}",
          "recurringForCount": "重复：%{interval}（共 %{count} 场）",
          "viewSeries": "查看系列",
          "recurrenceInterval": "重复周期",
          "recurrenceEnd": "结束",
          "recurrenceEndNever": "永不",
          "recurrenceEndOn": "指定日期",
          "recurrenceEndAfter": "指定场次后",
          "recurrenceEndOccurrences": "场次",
          "recurrenceUnit": {
            "daily": "天",
            "weekly": "周",
            "monthly": "个月"
          },
          "recurrenceWeekdays": "重复日",
          "recurrenceWeekdaysHint": "活动开始的那一天始终包含在内。",
          "recurrence": {
            "daily": "每日",
            "weekly": "每周",
            "monthly": "每月",
            "everyN": {
              "daily": "每%{count}天",
              "weekly": "每%{count}周",
              "monthly": "每%{count}个月"
            },
            "onDays": "%{interval}（%{days}）"
          },
          "occurrencesSection": "即将到来的场次",
          "skipOccurrence": "跳过此场次",
          "overrideOccurrence": "覆盖 %{date} 的场次",
          "overrideOccurrenceShort": "仅编辑此场",
          "overrideOccurrenceHint": "为这一场次单独覆盖字段。留空则沿用重复活动的设置。",
          "endSeriesHere": "从此场起停止",
          "splitSeriesHere": "编辑此场及之后的场次",
          "splitSeriesConfirm": "从此日期起将该系列作为新活动继续？此场及之后场次的报名会一并转移，新活动将打开以供编辑。",
          "excludedBadge": "已跳过",
          "noUpcomingOccurrences": "未来 12 周内没有即将到来的场次。",
          "endSeriesConfirm": "要在此日期之后停止重复吗? 将不再生成后续场次。",
          "skipOccurrenceSuccess": "场次已跳过。",
          "unskipOccurrence": "恢复此场次",
          "unskipOccurrenceSuccess": "场次已恢复。",
          "endSeriesSuccess": "系列已从该日期起结束。",
          "cancelledReason": "取消原因",
          "createdBy": "创建者",
          "signups": "报名",
          "signupsCount": "%{count} 人报名",
          "youAreHere": "您在这里",
          "attendance": "出席",
          "signupsLockedHint": "此活动的报名已锁定。",
          "alreadySignedUpHint": "您已报名了另一个席位。请先取消报名再切换。",
          "slotTakenHint": "此席位已被占用。",
          "currentSlot": "当前席位",
          "currentSlotHint": "这是该报名当前所在的席位。",
          "takenBy": "已由 %{username} 占用",
          "slotPickerHint": "为此报名选择一个席位。已被占用或不可用的席位无法选择。",
          "signupCtaHint": "报名参加此活动 — 您可以现在就选择具体席位，或稍后由管理员为您分配。",
          "noSlotYet": "尚无席位",
          "signupApproval": "报名审批",
          "signupStatuses": {
            "confirmed": "已确认",
            "tentative": "待定",
            "interested": "感兴趣",
            "pending": "待审批",
            "withdrawn": "已取消"
          },
          "signupApprovals": {
            "direct": "直接通过",
            "confirmation_required": "需要确认"
          },
          "unassignedSignupsHint": "这些成员已报名活动，但尚未分配席位。请在下方为他们分配席位或移除报名。",
          "taken": "已占用",
          "grantedRoles": "已授予的角色",
          "noEventAdminsYet": "尚无其他管理员或协管员。",
          "creator": "活动创建者",
          "eventTeamHint": "为其他成员授予此活动的管理员或协管员权限。管理员可以编辑活动，协管员可以管理报名。",
          "eventRole": "角色",
          "eventRoles": {
            "admin": "管理员",
            "moderator": "协管员"
          },
          "memberPicker": "成员",
          "spawnedEvents": "已生成的活动",
          "fromMission": "来自任务",
          "pickTemplate": "选择模板",
          "pickTemplateHint": "可选择以任务为起点 — 其信息、小队、飞船和席位会复制到活动中，活动也会关联回该任务。",
          "noTemplate": "不使用模板",
          "noTemplateHint": "从零开始创建活动。",
          "pickTemplateLoadFailed": "无法加载舰队的任务。",
          "pickTemplatePageFailed": "无法加载更多任务。",
          "pickTemplateSearch": "搜索任务",
          "pickTemplateNonePublished": "舰队进行中的任务尚未发布。",
          "pickTemplateNoneActive": "舰队没有进行中的任务。",
          "pickTemplateNoMatch": "没有与搜索匹配的已发布任务。",
          "changeTemplate": "更换模板",
          "clearTemplate": "清除模板",
          "myVehicle": "我的载具",
          "selectVehicle": "选择载具（可选）",
          "vehicleMismatchHint": "所选载具不符合此席位的要求。",
          "noFittingInHangar": "您的机库中没有符合此席位的载具。您仍然可以不选择载具直接报名。",
          "vehicleFitsHint": "将带来一艘符合此飞船要求的载具。",
          "notes": "备注",
          "upcomingTab": "即将到来",
          "pastTab": "已过去",
          "archivedTab": "已归档",
          "listTab": "列表",
          "calendarTab": "日历",
          "subscribeHint": "将日历订阅源 URL 复制到剪贴板，以便粘贴到您的日历应用中。",
          "visibilities": {
            "members": "成员",
            "officers": "军官",
            "fleet": "公开",
            "squadron": "仅中队"
          },
          "statuses": {
            "draft": "草稿",
            "open": "报名开放中",
            "locked": "报名已锁定",
            "active": "进行中",
            "completed": "已完成",
            "cancelled": "已取消",
            "past": "已过去"
          },
          "tabs": {
            "basic": "基本信息",
            "description": "描述与封面",
            "teams": "小队与飞船",
            "overview": "概览",
            "settings": "设置"
          },
          "calendar": {
            "month": "月",
            "week": "周",
            "weekTitle": "%{date} 所在周"
          },
          "repeats": "重复"
        },
        "contracts": {
          "tabs": {
            "details": "详情",
            "delivery": "运送",
            "crew": "船员与报酬",
            "goods": "货物"
          },
          "title": "标题",
          "description": "描述",
          "reward": "报酬",
          "deadline": "截止时间",
          "crewLimit": "队伍上限",
          "visibility": "可见性",
          "visibilities": {
            "members_only": "所有成员",
            "squadron_only": "仅中队"
          },
          "reimburseExpenses": "报销开支",
          "from": "取货地点",
          "to": "交付地点",
          "toHint": "送往你自己库存的交付会发送给你，由你亲自接收。",
          "toAuthorHint": "交付会发送给 %{username}，由其接收。",
          "myHangarInventory": "%{name}（我的机库）",
          "authorHangarInventory": "%{name}（%{username} 的机库）",
          "destinationRemoved": "已不可用",
          "lead": "负责人",
          "pendingCrew": "等待加入",
          "minQuality": "最低品质 %{value}",
          "pickedUp": "已取 %{quantity}",
          "itemName": "物品",
          "itemCategory": "类别",
          "itemUnit": "单位",
          "itemQuantity": "数量",
          "kind": {
            "label": "类型",
            "transport": "运输",
            "procurement": "采购",
            "crafting": "制造"
          },
          "state": {
            "draft": "草稿",
            "open": "开放",
            "in_progress": "进行中",
            "fulfilled": "已完成",
            "cancelled": "已取消",
            "expired": "已过期",
            "settled": "已结算"
          },
          "itemTypes": {
            "Commodity": "商品",
            "Component": "部件",
            "Equipment": "装备"
          },
          "qualityMatch": "匹配方式",
          "exactQuality": "正好 %{value}",
          "qualityMatches": {
            "at_least": "至少",
            "exact": "正好"
          },
          "itemQuality": "品质",
          "titleHint": "可选——不填时合约以所需货物命名",
          "postedBy": "发布者",
          "claimedBy": "接下者",
          "delivered": "已交付",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "进行中",
            "closed": "已结束",
            "mine": "我的",
            "completed": "已完成"
          }
        }
      },
      "commodity": {
        "name": "名称",
        "buyPrice": "买入",
        "sellPrice": "卖出",
        "retired": "已不在当前版本中",
        "containerSizes": "货柜尺寸（SCU）",
        "pieceVolume": "每件体积（SCU）",
        "consumable": "可消耗",
        "refinesInto": "精炼为",
        "refinedFrom": "精炼自",
        "availability": {
          "retired": "价格仅针对目录所在的版本记录，而该商品不在其中。",
          "craftedOnly": "没有终端交易此商品 —— 它是一种制造材料。",
          "none": "我们所知的终端都不买卖此商品。"
        },
        "chart": {
          "buyHighest": "买入，最高",
          "buyAverage": "买入，平均",
          "buyLowest": "买入，最低",
          "sellHighest": "卖出，最高",
          "sellAverage": "卖出，平均",
          "sellLowest": "卖出，最低"
        },
        "types": {
          "agricultural_supply": "农业物资",
          "alloy": "合金",
          "consumer_goods": "消费品",
          "drink": "饮品",
          "food": "食品",
          "gas": "气体",
          "hpmc": "HPMC",
          "manmade": "人造物",
          "medical_supply": "医疗物资",
          "metal": "金属",
          "military_supply": "军用物资",
          "mineral": "矿物",
          "natural": "天然物",
          "nonmetals": "非金属",
          "plasma_fuel": "等离子燃料",
          "processed_goods": "加工品",
          "quantum_fuel": "量子燃料",
          "rmc": "RMC",
          "scrap": "废料",
          "vice": "违禁品",
          "waste": "废弃物"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "装备类型",
        "itemType": "物品类型",
        "subType": "子类型",
        "weaponClass": "武器类别",
        "slot": "部位",
        "size": "尺寸",
        "grade": "等级",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "名称",
        "manufacturer": "制造商",
        "retired": "已不在当前版本中",
        "noMetrics": "该物品没有记录任何数据。",
        "availability": {
          "retired": "价格只针对目录当前所在的版本记录，而该物品不在其中。",
          "craftedOnly": "没有终端出售此物品——它由下方的配方制造。",
          "none": "没有终端买卖此物品。"
        },
        "stats": {
          "damageReduction": "伤害减免",
          "temperatureRating": "耐温范围",
          "radiationProtection": "辐射防护",
          "radiationScrubRate": "辐射清除速率",
          "gForceTolerance": "G力耐受",
          "carryingCapacity": "携带容量",
          "magazineSize": "弹匣容量",
          "rateOfFire": "射速",
          "range": "有效射程",
          "weaponClass": "武器类别",
          "coreCompatibility": "核心兼容性",
          "backpackCompatibility": "背包兼容性",
          "volume": "体积"
        },
        "sorts": {
          "damageReduction": "伤害减免",
          "radiationProtection": "辐射防护",
          "gForceTolerance": "G力耐受",
          "rateOfFire": "射速",
          "range": "射程",
          "storage": "容量",
          "volume": "体积"
        }
      },
      "notifications": {
        "inbox": "收件箱",
        "archive": "归档",
        "unreadOnly": "仅未读",
        "status": "状态",
        "type": "类型",
        "selectPrompt": "选择一条通知以阅读",
        "noBody": "此通知没有更多详情。",
        "archivesOn": "移至归档",
        "deletesOn": "删除"
      },
      "unlistedModel": {
        "linkHint": "%{identifier} 对应目录中的哪艘飞船？建议来自导出数据，可能有误。"
      },
      "slug": "Slug",
      "inventories": {
        "source": "来源",
        "sources": {
          "vehicle": "飞船",
          "handMade": "手动创建"
        }
      },
      "inventoryItems": {
        "name": "名称",
        "category": "分类",
        "entryType": "记录类型",
        "quantity": "数量",
        "quality": "品质",
        "notes": "备注",
        "itemType": "目录",
        "categories": {
          "commodity": "商品",
          "component": "组件",
          "weapon": "武器",
          "equipment": "装备",
          "ammunition": "弹药",
          "consumable": "消耗品",
          "other": "其他"
        },
        "entryTypes": {
          "deposit": "入库",
          "withdrawal": "出库"
        },
        "units": {
          "scu": "SCU",
          "units": "件"
        }
      },
      "shipHistory": {
        "sales": "促销历史",
        "salesCount": "记录的促销",
        "lastSale": "最近一次促销",
        "averageGap": "平均间隔",
        "days": "%{count} 天",
        "ongoing": "进行中",
        "priceHistory": "现金购买价历史",
        "firstPriced": "首次定价",
        "priceRemoved": "价格已移除",
        "wishlist": "每月心愿单新增",
        "patchChanges": "更新改动",
        "notRecordedYet": "仅从开始记录之日起统计，因此飞船可能尚无记录。"
      },
      "buildCompare": {
        "from": "起始版本",
        "to": "目标版本",
        "appeared": "新增",
        "vanished": "移除",
        "changed": "变更",
        "notRecorded": "其中一个版本没有记录该目录。",
        "needsTwoBuilds": "只记录了一个版本，无法进行对比。",
        "pickTwoBuilds": "请选择两个不同的版本。",
        "failed": "无法对比这两个版本。",
        "andMore": "还有 %{count} 项",
        "catalogues": {
          "components": "部件",
          "equipment": "装备",
          "commodities": "商品",
          "models": "舰船"
        }
      },
      "dockAccess": {
        "ramp": "坡道",
        "lift": "升降机",
        "tractor_beam": "牵引光束"
      },
      "dockTypes": {
        "vehiclepad": "载具停放位",
        "garage": "车库",
        "landingpad": "停机坪",
        "dockingport": "对接口",
        "hangar": "机库",
        "cargogrid": "货运格栅"
      },
      "payouts": {
        "currency": "货币",
        "archived": "已归档",
        "activeTours": "当前",
        "amount": "金额",
        "description": "说明",
        "entryType": "类型",
        "expense": "支出",
        "income": "收入",
        "participant": "谁",
        "notes": "备注",
        "occurredAt": "时间",
        "paid": "支出",
        "held": "持有",
        "share": "应得",
        "net": "余额",
        "profit": "利润",
        "totalIncome": "收入",
        "totalExpenses": "支出",
        "guest": "访客",
        "username": "用户名",
        "name": "名称",
        "sends": "支付给",
        "receives": "收取",
        "settled": "已结算",
        "open": "进行中",
        "owes": "应付",
        "isOwed": "应收",
        "even": "已结清",
        "title": "标题",
        "fleet": "舰队",
        "startsAt": "开始于",
        "inviteLink": "邀请链接",
        "participants": "人数",
        "weight": "权重",
        "shares": "份",
        "customWeight": "自定义权重",
        "preview": "预览 · 结算前会变动",
        "joinRequestPending": "申请待处理",
        "payer": "付款方",
        "declineReason": "原因",
        "review": {
          "pending": "待审核",
          "approved": "已批准",
          "declined": "已拒绝"
        }
      },
      "shipSizes": {
        "extra_extra_small": "斯努布克拉夫特 (XXS)",
        "extra_small": "特小号 (XS)",
        "small": "小型(S)",
        "medium": "中号 (M)",
        "large": "大号（L）",
        "extra_large": "特大号 (XL)",
        "capital": "资本（C）"
      },
      "relationships": {
        "party": "名称",
        "since": "自",
        "tabs": {
          "accepted": "已建立",
          "incoming": "收到的",
          "outgoing": "已发送",
          "ignored": "已忽略"
        },
        "user": {
          "handle": "用户名"
        },
        "fleet": {
          "handle": "舰队标识"
        },
        "requested": "请求已发送",
        "friend": "已是好友"
      },
      "blueprint": {
        "name": "名称",
        "craftTime": "制造时间",
        "slots": "槽位",
        "materials": "材料",
        "quality": "品质",
        "missionSlots": {
          "location": "地点",
          "objects": "目标物",
          "target": "目标",
          "ship": "飞船",
          "cargo": "货物",
          "rank": "等级",
          "danger": "危险度",
          "contract": "合约",
          "other": "可变"
        },
        "missionSlotsHint": "‹尖括号› 内的内容由游戏在提供合约时填入。",
        "atNeutral": "Q500 时为 %{value}",
        "whatYouGet": "成品属性",
        "fromSlots": "%{count} 个槽位",
        "factorOnly": "仅系数 — 目录中无该属性数值",
        "heldIn": "存于",
        "heldOn": "存于",
        "fromHangar": "机库",
        "makes": "产出",
        "makesA": "制造蓝图 · 产出",
        "makesUnknown": "制造蓝图 · 产出物不在任何目录中",
        "retired": "已移除",
        "minQuality": "最低 %{quality}",
        "belowGate": "低于该槽位门槛 — 品质低于 %{quality} 的材料无法放入。",
        "unvalued": "受影响 — 游戏未给出数值",
        "noStats": "该槽位不影响任何属性 — 材料只需存在即可。",
        "noMaterials": "游戏文件未列出该蓝图的材料。",
        "setEverySlot": "设置所有槽位",
        "qualityAll": "全部槽位为 %{quality}",
        "qualityRange": "各槽位 %{from}–%{to}",
        "anyOf": "在这 %{total} 项中任选 %{count} 项",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "获取途径",
        "fleetOwners": "谁能制造",
        "ownedByCount": "%{count} 人拥有",
        "sourceSummary": "%{count} 个来源 · %{orgs} 个组织",
        "unattributed": "未标明组织",
        "minPoints": "%{points} 点起",
        "noKnownSource": "无已知来源",
        "noSourceLead": "没有任务或场景会发放此蓝图。",
        "noSourceBody": "游戏文件未将其列入任何奖励池，因此无从指引。",
        "empty": "没有匹配的蓝图。",
        "craftableTypes": {
          "Component": "部件",
          "Equipment": "装备",
          "Commodity": "商品"
        },
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "非法"
        },
        "kinds": {
          "contract": "合约",
          "scenario": "场景"
        },
        "duration": {
          "hours": "%{count} 小时",
          "minutes": "%{count} 分",
          "seconds": "%{count} 秒"
        }
      },
      "gameMission": {
        "locationNamedInText": "简报中提及",
        "locations": "任务地点",
        "locationKinds": {
          "surface": "在行星或卫星上",
          "space": "在太空中",
          "mixed": "行星、卫星或太空",
          "unknown": "地点未知"
        },
        "location": "地点",
        "cannotLand": {
          "surface": "%{ship} 无法降落：此合约位于行星或卫星上",
          "mixed": "可能会把 %{ship} 带到它无法降落的行星或卫星"
        },
        "calculatedInGame": "由游戏计算",
        "blueprints": "蓝图",
        "name": "名称",
        "org": "发布方",
        "offeredBy": "发布方",
        "offeredByUnknown": "未注明委托方",
        "standing": "声望",
        "kind": "类型",
        "kinds": {
          "career": "职业",
          "contract": "一次性"
        },
        "difficulty": "难度",
        "difficultyAxes": {
          "mechanicalSkill": "操作技巧",
          "mentalLoad": "心智负担",
          "riskOfLoss": "损失风险",
          "gameKnowledge": "游戏理解"
        },
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "不法"
        },
        "rewards": "奖励",
        "rewardKinds": {
          "blueprint": "蓝图",
          "reputation": "声望",
          "item": "物品",
          "badge": "徽章",
          "currency": "报酬"
        },
        "oneOfASet": "一组中的一件",
        "briefing": "任务简报",
        "templatedNote": "标记的部分由游戏在发布任务时填入。",
        "payoutNote": "报酬由游戏在生成任务时计算，因此游戏文件只为少数合同写明了金额。",
        "noRewards": "游戏文件未为此任务写明奖励。",
        "unreleased": "未在正式版",
        "retired": "已移除"
      },
      "fleetDirectory": {
        "name": "舰队",
        "memberCount": "成员",
        "createdAt": "最新",
        "language": "语言",
        "recruiting": "招募中",
        "notRecruiting": "未招募",
        "roleplay": "角色扮演",
        "rsiSid": "SID %{sid}"
      },
      "tour": {
        "step": "第 %{current} 步，共 %{total} 步"
      },
      "vehiclePlaque": {
        "style": "样式",
        "styles": {
          "brass": "黄铜",
          "hud": "Fleetyards 界面",
          "gunmetal": "枪铁色",
          "blueprint": "船坞蓝图",
          "salvage": "铆接废料",
          "glass": "磨砂玻璃",
          "carbon": "碳纤维与信号红",
          "walnut": "胡桃木与黄铜",
          "neon": "派罗霓虹",
          "manufacturer": "制造商样式"
        },
        "captain": "舰长",
        "captainInfo": "留空则使用你在公开机库中显示的名称。",
        "registry": "注册编号",
        "operationsGroup": "行动组",
        "title": "命名铭牌",
        "dedication": "献词",
        "launchedOn": "下水日期",
        "launchPort": "下水港口",
        "affiliation": "所属"
      },
      "vehicleOverview": {
        "picture": "图片",
        "pictureInfo": "替代默认渲染图显示，在你的公开机库以及你共享此舰船的舰队中也会显示。",
        "ownPicture": "你的图片",
        "serial": "序列号 %{serial}",
        "since": "自 %{date} 起在机库中",
        "logSummary": "%{count} 条条目 · %{public} 条公开",
        "cargoFill": "已装载 %{stowed} / %{capacity} SCU",
        "cargoStowed": "已装载 %{stowed} SCU",
        "cargoMeter": "货舱装载",
        "configuration": "配置",
        "noPaint": "标准涂装",
        "ownedPaints": "你的涂装",
        "availablePaints": "涂装",
        "ownedPaintsCount": {
          "one": "%{count} 款涂装",
          "other": "%{count} 款涂装"
        },
        "visibility": "可见性",
        "showPublic": "在我的公开机库中显示",
        "showName": "显示名称",
        "fleets": "服役于",
        "status": "状态",
        "searchPaints": "搜索涂装",
        "location": "位置",
        "noLocation": "未设置",
        "noGroups": "无分组",
        "planLoadout": "规划配装",
        "pictureUpload": "上传",
        "pictureGallery": "图库",
        "stockPicture": "标准图片",
        "waysToGetIt": "获取途径"
      },
      "vehicleLog": {
        "entries": "日志条目",
        "title": "标题",
        "loggedAt": "日期",
        "loggedAtPlaceholder": "现在",
        "body": "内容",
        "public": "在我的公开机库中显示",
        "publicShort": "公开",
        "publicByDefault": "新条目默认公开",
        "filters": {
          "all": "全部",
          "public": "公开",
          "private": "私密"
        },
        "entryCount": {
          "one": "%{count} 条条目",
          "other": "%{count} 条条目"
        },
        "privateShort": "私密",
        "stats": "日志",
        "statsEntries": "条目",
        "statsPublic": "公开",
        "statsSince": "始于"
      },
      "vehicleEdit": {
        "tabs": {
          "general": "常规",
          "visibility": "可见性",
          "notifications": "通知",
          "names": "名称",
          "groups": "分组",
          "picture": "图片"
        }
      },
      "vehicleLoadout": {
        "tabs": {
          "paints": "涂装",
          "modules": "模块",
          "upgrades": "附加组件",
          "weapons": "武器",
          "missiles": "导弹",
          "shields": "护盾发生器",
          "powerPlants": "发电机",
          "coolers": "散热器",
          "quantumDrives": "量子引擎",
          "radar": "雷达",
          "lifeSupport": "生命支持",
          "flightBlades": "飞行刀片"
        },
        "comingSoon": "即将推出",
        "ownedModules": "你拥有的模块",
        "nothingFitted": "未装配",
        "owned": "已拥有",
        "noSlots": "这艘舰船目前还没有可在此装配的内容",
        "unavailableModule": "模块已不可用",
        "noFigureChange": "不改变舰船的任何数值",
        "loadoutName": "配装名称",
        "stock": "原厂",
        "notFlightReady": "只有可飞行的舰船才能使用配装",
        "slots": {
          "default": "模块槽位",
          "front": "前部模块槽位",
          "rear": "后部模块槽位",
          "left": "左侧模块槽位",
          "right": "右侧模块槽位"
        },
        "unavailable": {
          "modules": "该舰船不支持模块",
          "upgrades": "该舰船没有可用的附加组件"
        },
        "none": "无"
      },
      "loadoutPicker": {
        "emptySocket": "空",
        "search": "搜索",
        "owned": "已拥有",
        "stock": "原厂",
        "manufacturer": "制造商",
        "sortName": "名称",
        "count": "%{total} 个中的 %{count} 个",
        "total": {
          "one": "%{count} 个选项",
          "other": "%{count} 个选项"
        },
        "reset": "重置筛选",
        "leaveEmpty": "留空",
        "noMatches": "没有匹配项",
        "close": "关闭"
      }
    }
  }
}
